import React from "react";
import pre_primary from "./image/pre-primary.jpg";

import primary from "./image/newcovers/pre primary curriculum.jpg";
import secondary from "./image/curriculum/Sec. Curriculum body image.jpg";
import sr_secondary from "./image/newcovers/Senior sec.curriculum pic 2.jpg";

//alumni
import nikhel from "./image/nikhel.jpg";
import ankita from "./image/ankita.jpg";
import sandeep from "./image/sandeep.jpg";
import bharat_bansal from "./image/bharat_bansal.jpg";
import subhadeep from "./image/subhadeep.jpg";
import karan from "./image/karan.jpg";
//
import JinsiPhoto from "./image/newImg/Jinsi-picture.png";
import SumantaPhoto from "./image/newImg/SumantaKar.png";
import DebarotiPhoto from "./image/debaroti.png";
import FaridabadPrincipal from "./image/faridabad_principal_new.jpg";
import runamile from "./image/runamile.png";
//
import result_10 from "./image/result-10.jpg";
import result_10_1 from "./image/result-10-1.jpg";
import result_10_2 from "./image/result-10-2.jpg";
import result_10_3 from "./image/result-10-3.jpg";
import result_12_1 from "./image/result-12-1.jpg";
import result_12_2 from "./image/result-12-2.jpg";
import result_12_3 from "./image/result-12-3.jpg";

//
import laboratories from "./image/laboratories.jpg";
import library from "./image/library_1.jpg";
//
import life_skill_1 from "./image/life_skill_1.jpg";
import life_skill_2 from "./image/life_skill_2.jpg";
import vocational_1 from "./image/vocational_1.jpg";
import vocational_2 from "./image/vocational_2.jpg";
import skill_based from "./image/skill_based.jpg";
import skill_based_2 from "./image/skill_based_2.jpg";
import annual_1 from "./image/annual_1 new.JPG";
import annual_2 from "./image/annual_2 new.JPG";
import annual_3 from "./image/annual_3.jpg";
import sports_club from "./image/sports_club.jpg";
import environment_club from "./image/environment_club.jpg";
import expression_club from "./image/expression_club.jpg";
import student_council_1 from "./image/student_council_1.jpg";
import student_council_2 from "./image/student_council_2.jpg";
import student_council_3 from "./image/student_council_3.jpg";
import ncc_1 from "./image/ncc_1.jpg";
import school_band_1 from "./image/school_band_1.jpg";
import scouts_1 from "./image/scouts_1.jpg";
import bus_1 from "./image/bus_1.jpg";
import award_1 from "./image/award_1.jpg";
import award_2 from "./image/award_2.jpg";
import award_3 from "./image/award_3.jpg";
import award_4 from "./image/award_4.jpg";
import award_5 from "./image/award_5.jpg";
import award_6 from "./image/award_6.jpg";
import award_7 from "./image/award_7.jpg";
import award_8 from "./image/award_8.jpg";
import award_9 from "./image/award_9.jpg";
import award_10 from "./image/award_10.jpg";
import pre_primary_1 from "./image/pre_primary_1.jpg";
import pre_primary_2 from "./image/pre_primary_2.jpg";
import primary_1 from "./image/primary_1.jpg";
import secondary_1 from "./image/secondary_1.jpg";
import secondary_2 from "./image/secondary_2.jpg";
import sr_secondary_1_1 from "./image/sr_secondary_1_1.jpg";
import sr_secondary_2 from "./image/sr_secondary_2.jpg";
import career_1 from "./image/career_1.jpg";
import career_2 from "./image/career_2.jpg";
import career_4 from "./image/career_4.jpg";
import career_5 from "./image/career_5.jpg";
import sports_1 from "./image/sports_1.jpg";
import sports_3 from "./image/sports_3.jpg";
import arts_club from "./image/arts_club.jpg";
import playground_1 from "./image/playground_1.jpg";
import vision from "./image/vision.jpg";
import mission from "./image/mission.jpg";
import anti_bullying from "./image/anti_bullying.jpg";
import health_1 from "./image/health_1.jpg";
import health_2 from "./image/health_2.jpg";
import value_club from "./image/value_club.jpg";
import social_impact from "./image/social_impact.jpg";
import gender_sensitivity from "./image/gender_sensitivity.jpg";
import english_club from "./image/english_club.jpg";
import budding_1 from "./image/budding_1.jpg";
import budding_2 from "./image/budding_2.jpg";
import sdmc from "./image/sdmc.jpg";
import sdmc_2 from "./image/sdmc_2.jpg";
import house_system from "./image/house_system.jpg";
import trip_1 from "./image/trip_1.jpg";
import trip_cover from "./image/trip_cover.jpg";
import trip_cover_1 from "./image/trip_cover_1.jpg";
import trip_4 from "./image/trip_4.jpg";
import primary_curriculum from "./image/primary_curriculum.jpg";
import interactive from "./image/interactive.jpg";
import happy_classroom from "./image/happy_classroom.jpg";
import experimental_learning from "./image/experimental_learning.jpg";
import spacious_classroom from "./image/spacious_classroom.jpg";
import spacious_classroom_2 from "./image/spacious_classroom_2.jpg";
import stem_lab from "./image/stem_lab_1.jpg";
import stem_lab_2 from "./image/stem_lab_2 new.jpeg";
import computer_lab_1 from "./image/computer_lab_1.jpg";
import computer_lab_2 from "./image/computer_lab_2.jpg";
import laboratories_2 from "./image/laboratories_2.jpg";
import home_science from "./image/home_science.jpg";
import home_science_2 from "./image/home_science_2.jpg";
import arts from "./image/arts.jpg";
import arts_2 from "./image/arts_2.jpg";
import library_2 from "./image/library_2.jpg";
import cultural from "./image/cultural.jpg";
import cultural_2 from "./image/cultural_2.jpg";
import cultural_3 from "./image/cultural_3.jpg";
import cultural_4 from "./image/cultural_4.jpg";
import bio_lab from "./image/bio_lab.jpg";
import chem_lab from "./image/chem_lab_1.jpg";
import phy_lab from "./image/phy_lab.jpg";
import infrastructure_1 from "./image/infrastructure.jpg";
import faculty_1 from "./image/newImg/1.png";
import faculty_2 from "./image/newImg/2.png";
import faculty_3 from "./image/newImg/3.png";
import faculty_4 from "./image/newImg/4.png";
import faculty_5 from "./image/newImg/5.png";
import faculty_6 from "./image/newImg/6.png";
import aa from "./image/newImg/aa.jpeg";
import a from "./image/newImg/a.jpg";
import b from "./image/newImg/b.jpg";
import c from "./image/newImg/c.jpg";
import d from "./image/newImg/d.jpg";
import e from "./image/newImg/e.jpg";

import pre1 from "./image/newImg/Preprimary (1).jpeg";
import pre2 from "./image/newImg/Preprimary (2).jpeg";

import red from "./image/newImg/Houses (1).jpg";
import blue from "./image/newImg/Houses (3).jpg";
import yellow from "./image/newImg/Houses (4).jpg";
import green from "./image/newImg/Houses (5).jpg";

import expression from "./image/newImg/expression.png";
import ba from "./image/newImg/ba.png";

import media1 from "./image/newImg/media/2.jpg";
import media2 from "./image/newImg/media/4.jpg";
import media3 from "./image/newImg/media/5.jpg";
import media4 from "./image/newImg/media/6.jpg";
import media5 from "./image/newImg/media/7.jpg";
import media from "./image/newImg/media/8.jpg";
import media6 from "./image/newImg/media/9.jpg";
import media7 from "./image/newImg/media/10.jpg";
import media8 from "./image/newImg/media/11.jpg";
import media9 from "./image/newImg/media/12.jpg";
import media10 from "./image/newImg/media/13.jpg";
import media11 from "./image/newImg/media/14.jpg";
import media12 from "./image/newImg/media/15.jpg";
import media13 from "./image/newImg/media/16.jpg";
import media14 from "./image/newImg/media/17.jpg";
import media15 from "./image/newImg/media/18.jpg";

import sports_club_icon from "./image/clubs/sportsClubIcon.png";
import anti_bullying_icon from "./image/clubs/antiBullyingIcon.png";
import environment_club_icon from "./image/clubs/environmentClubIcon.png";
import health_club_icon from "./image/clubs/healthClubIcon.png";
import value_club_icon from "./image/clubs/valueClubIcon.png";
import social_impact_club_icon from "./image/clubs/socialImpactClub.png";
import gender_club from "./image/clubs/genderClub.png";
import english_club_icon from "./image/clubs/englishClub.png";

//
import orientation_1 from "./image/orientation_1.jpg";
import orientation_2 from "./image/orientation_2.jpg";
import orientation_3 from "./image/orientation_3.jpg";
import orientation_4 from "./image/orientation_4.jpg";
import book from "./image/book.jpg";
import waste from "./image/waste.jpg";
import waste_2 from "./image/waste_2.jpg";
import paper from "./image/paper.jpg";
import republic_1 from "./image/republic_1.jpg";
import republic_2 from "./image/republic_2.jpg";
import republic_3 from "./image/republic_3.jpg";
import covid from "./image/covid.jpg";
import mother from "./image/mother.jpg";
import first_aid from "./image/first_aid.jpg";
import basant_1 from "./image/basant_1.jpg";
import basant_2 from "./image/basant_2.jpg";
import pareeksha from "./image/pareeksha.jpg";
import pareeksha_2 from "./image/pareeksha_2.jpg";
import heritage from "./image/heritage.jpg";
import farewell from "./image/farewell.jpg";
import farewell_2 from "./image/farewell_2.jpg";
import environment from "./image/environment.jpg";
import fashion from "./image/fashion.jpg";
import fire from "./image/fire.jpg";
import donation_1 from "./image/donation_1.jpg";
import donation_2 from "./image/donation_2.jpg";

import { FaSchool } from "react-icons/fa";
//
export const sidebar_data_vision = [
  {
    title: "Vision & Mission",
    navigation: "vision-and-mission",
  },
  {
    title: "Message From Leadership",
    navigation: "message",
  },
  {
    title: "Academics & Curriculum",
    navigation: "nep",
  },
  {
    title: "Beyond Curriculum",
    navigation: "house-clubs",
  },
  {
    title: "Sports & Fitness",
    navigation: "sports",
  },
  {
    title: "Faculty & Staff",
    navigation: "faculty-staff",
  },
  {
    title: "Events & Happenings",
    navigation: "events",
  },
  {
    title: "Parents' & Students' Voice",
    navigation: "parents",
  },
  {
    title: "Infrastructure & Facilities",
    navigation: "infrastructure",
  },
  {
    title: "Achievements and Laurels",
    navigation: "awards",
  },
  {
    title: "News & Media Coverage",
    navigation: "news",
  },
  {
    title: "Admissions",
    navigation: "admissions",
  },
];
export const academics_sidenav = [
  {
    title: "NEP 2020 Ready School ",
    navigation: "nep",
  },
  {
    title: "Curriculum ",
    navigation: "curriculum",
  },
  {
    title: "Pedagogical Approach",
    navigation: "pedagogi",
  },
  {
    title: "Life Skill Curriculum",
    navigation: "life-skill",
  },
  {
    title: "Assessment",
    navigation: "examination",
  },
  {
    title: "Skill & Vocational Subjects",
    navigation: "skill-vocational",
  },
  {
    title: "Results",
    navigation: "results",
  },
  {
    title: "Booklist",
    navigation: "books",
  },
];
export const beyond_sidenav = [
  {
    title: "Houses & Clubs",
    navigation: "house-clubs",
  },
  {
    title: "Student Council",
    navigation: "student-council",
  },
  {
    title: "Trips, Excursions & Field Visits",
    navigation: "trips",
  },
  {
    title: "NCC, Scouts & Guides",
    navigation: "ncc-scouts",
  },
];
//
export const vision_mission = [
  {
    id: 1,
    title: "Vision",
    description:
      "Our vision at HGS is to empower students through a transformative blend of academic excellence, innovation, and holistic development. We aspire to create a dynamic learning environment where education is furthermore enriched by technology and creativity. By nurturing each child's unique potential, we aim to develop lifelong learners who are not only academically accomplished but also socially responsible, compassionate, and prepared to lead in a rapidly changing world. Our ultimate goal is to inspire our students to become confident, ethical, and engaged citizens who contribute positively to society.",
    description_image: [vision],
  },
  {
    id: 2,
    title: "Mission",
    description:
        "Our mission at HGS is to bring our vision to life by delivering a well-rounded, future-focused education. We are dedicated to fostering academic excellence through a modern curriculum that integrates technology, creativity, and experiential learning. By providing opportunities in sports and co-curricular activities, we aim to develop students' physical, emotional, and social well-being. We commit to cultivating an inclusive and nurturing environment where educators and students collaborate to enhance learning experiences. Through personalized guidance, diverse learning approaches, and character-building initiatives, we empower our students to grow into responsible and compassionate citizens. " , 
    description_image: [mission],
  },
];
export const message_data = [
  {
    id: 1,
    title: "President",
    name: "Rakesh Jinsi",
    image: JinsiPhoto,
    description:
      "Rakesh Jinsi, an engineer by degree, has 41 years of experience in leadership roles at several institutions, including SOS Children's Villages. Presently running Khushboo, a daycare centre for children with severe mental and multiple disabilities, he has always been active in national level bodies such  as the National Human Rights Commission and Voluntary Action Network of India (VANI), the Apex body of the NGO sector.",
    extra_description: [
      `"I firmly believe that each and every child deserves an education that is advanced, detail-oriented yet nurturing and holistic. As President of SOS Children’s Villages of India, I wish to provide the best possible learning experience to the future leaders of our country, so that all children are able to reach their maximum potential and achieve their dreams. Students end up spending most of their childhood within classrooms, so it is essential that within those walls they are imparted proper theoretical knowledge, practical aptitude, communal values, essential life skills, and an understanding of how the world works and their place in it. ,
      "Adequate grooming and learning of children at a young age leads to them being strong, confident, hard-working and intelligent individuals, attributes that I deem necessary for the new era of technology and scientific progress we are heading towards."`,
    ],
  },
  {
    id: 2,
    title: "Secretary General",
    name: "Sumanta Kar",
    image: SumantaPhoto,
    description:
      "Education at SOS HGSs has always meant the Holistic Development of a student – we believe that each child is entitled to the best possible skill set for their future, therefore, each child entrusted with us will receive an education that is in its finest form. ",
    extra_description: [
      "Education is preparation for life, it should be an enjoyable, interactive and ongoing process to make the students confident young adults, sensitive to global issues, committed citizens who are aware of the happenings of the world and sensible individuals with a positive attitude. ",
      "Students should have a strong character and a good understanding of their humane and emotional sides. All our HGSs have been actively engaged in relating to, understanding and working with communities around our schools.",
      "Safeguarding of children remains a top priority and they are nurtured through a theme-based curriculum and actively engage in experiential learning. Our teachers and principals play a pivotal role in the development of each child. Our alumni are our brand ambassadors, who leave a lasting footprint in whatever profession they choose to pursue. Each student who joins us becomes a future world leader, ready to bring progressive change and make our nation proud.",
    ],
  },
  {
    id: 3,
    title: "Head- Education & Child Development",
    name: "Debaroti Bose",
    image: DebarotiPhoto,
    description:
      "I believe that school should be the experience of a lifetime. Our school experience sets the stage for success later in life and provides a lifetime of positive memories for our students. We are proud of our continuous goal of providing an excellent education for our students.We have a dynamic, hardworking faculty who are involved in education to benefit the students.The entire gamut of school education is transforming the teaching-learning process. ",
    extra_description: [
      "In the modern concept of schooling, teaching has become redundant, paving the way for the facilitation of learning through knowledge sharing. The wave of digital learning and cloud computing is reaching new heights.",
      " In all this whirlwind of new-age technology, it is important to charge ahead but with one’s head firmly on one’s shoulders. HGS strives to inculcate moral values, manners, responsibilities among students so that they may build a world free of all the evils.",
      "Students here are encouraged to dream, groomed to give wings to their dreams, to take off and explore the unexplored. The plethora of interesting & exciting opportunities available to youngsters today often leave them with an array of things to do.",
      " It is important therefore to help them build their focus on the subject that draws them most and gives shape to their vision. A student is made to blossom intellectually, morally, and spiritually. As Swami Vivekananda said, “Take up one idea. Make that one idea your life – think of it, dream of it, and live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.”",
    ],
  },
  {
    id: 4,
    title: "Principal",
    name: "Ms. Deboleena Chowdhuri",
    image: FaridabadPrincipal,
    description: `I am honored and feel very privileged to be the Principal of HGS,
        Faridabad. It is known for its outstanding educational programme that is robust in its
        academic aims, innovative in its instructional approach and rigorous in its pursuit of
        excellence.`,
    extra_description: [
      `We offer varied opportunities for the students to explore the world and discover themselves.
            As education is the key to success in the future, it illuminates a person’s mind and thinking.’
            Learning never exhausts the mind..’ It polishes our mind, reinforces our thoughts, and
            strengthens our character and behaviour towards others.`,
      `In our institution, the goal of education is to provide an environment for the students who
            incorporate authentic learning and personal development. It allows learners to prepare for
            the ever changing and ever evolving world. Our school is focused on establishing all round
            development and academic excellence. We nurture talent by incorporating sports and
            varied co-curricular activities in our curriculum. We provide value-based education
            synergized with modern teaching and learning methodology to produce an emotionally
            sound generation.`,
      `Parents play an integral part in the development of the child. The foundation of a successful
            school is the cooperation between the students, staff, and parents. We work to develop and
            sustain productive partnerships and connections with our parents.`,
      `“Teachers should build classroom climates where errors are welcome, student engagement
            is the norm, questioning is high, and students gain reputations as effective learners.” We
            completely agree with John Hattie, our teachers help the students to blossom and grow as
            individuals, enabling them to realize their true potential.`,
      `We are fortunate to have an incredibly supportive, committed management who are
            available round the clock to provide all the best possible infrastructure and facilities to
            create a favorable environment for holistic development and growth of our students.`,
    ],
  },
];
export const infrastructure = [
  {
    id: 1,
    infra_title: "Infrastructure",
    description: `HGS Faridabad was established in 1986, by the SOS Children’s Villages Organization. The campus is located in the prime location of Faridabad, Sector 29. With a sprawling campus area of 3.5 acres and a pollution free environment, we promise the well-being and protection of all the kids. The alma-mater and the grounds of HGS were all planned and designed by a German Architect and the unique structure of the building does not compromise with the classrooms or playgrounds of the students. Ever since the school has been established, it has only grown and paved its way to being one of the safest and premier educational institutions. To facilitate the students in all the activities, libraries, labs, grounds, and auditoriums have been built. This would not only help them explore different areas of interest but also help them hone their skills.`,
    image: [infrastructure_1],
  },
  {
    id: 1,
    infra_title: "Spacious Classrooms",
    description: `The School can boast spacious, well-ventilated, and excellently furnished classrooms to make the students learning comfortable and enjoyable. Individual tables and chairs are provided to students to make them independent and self-reliant. These specially designed tables and chairs can be brought together very easily to form circles and semicircles while the lesson is in progress to have group discussions and activities.`,
    image: [spacious_classroom],
  },
  {
    id: 2,
    infra_title: "",
    description: `To avoid carrying heavy school bags,  a special storage facility is provided for every student in the classroom. In all classrooms, display boards are provided to display creative chart works, drawings and paintings, and craftworks. The school has the best infrastructure catering for today’s learning environment – like smart interactive classrooms with ICR facilities and the use of smart board technologies for conducive learning. This facilitates comprehensive learning and makes it enjoyable and an interesting process of learning.
    `,
    image: [spacious_classroom_2],
  },
  {
    id: 3,
    infra_title: "STEM Lab",
    description: `STEM education experiences are made available in a variety of settings by the school as a way of fostering a diverse STEM workforce. Educators are focused on improving science and mathematics instructions employing several approaches to K-12 STEM education. Students also were given opportunities to spend time with professionals in STEM fields. 
    `,
    image: [stem_lab],
  },
  {
    id: 4,
    infra_title: "",
    description: `STEM is an abbreviation that stands for 4 closely related subjects that are Science, Technology, Engineering and Mathematics. These four theoretical and practical subjects are taught together under STEM education and starting from basics to giving precise knowledge of the subjects, professional guidelines are available at the school’s STEM lab. The students are taught by giving them real-life world problems and they are to solve these problems by theoretical and practical approach. 
    `,
    image: [stem_lab_2],
  },
  {
    id: 3,
    infra_title: "Computer Lab",
    description: `The school has a highly sophisticated computer lab. It is equipped with a computing facility with 40 i3 computers connected through the Local Area Network as well as Wifi. The high-speed internet connectivity of 11 Mbps (24*7) to access vast intellectual resources. These facilities are an integral part of the curriculum. Students are expected to use computers in their day-to-day studies to meet the challenges of modern learning and to keep pace with the global scenario `,
    image: [computer_lab_1],
  },
  {
    id: 4,
    infra_title: "Biology Lab ",
    description: `Students are encouraged to learn through experiments and grasp diverse ideas beyond their textbooks in the Biology lab, which is separate from traditional classroom instruction. Experiments and observations make learning more engaging and enjoyable. Experiments are fun for students because they learn something new from the outcomes. Every student in grades I through XII has the opportunity to do the practical under the supervision of the professors.`,
    image: [bio_lab],
  },
  {
    id: 4,
    infra_title: "Chemistry Lab ",
    description: `HGS has a fantastic Chemistry lab with all of the latest and best-in-class apparatus and chemicals, as well as a wonderful learning atmosphere where students do practicals under the supervision of the lecturers. All precautions are followed, and the youngsters learn the fundamentals of chemistry by doing their own experiments, observing, and drawing conclusions.
    `,
    image: [chem_lab],
  },
  {
    id: 4,
    infra_title: "Physics Lab",
    description: `Physics lab of HGS has all the up-to-date equipment. This lab assists students in developing a broad range of basic experimental physics and data analysis skills and tools. It is also intended for each student to conduct experiments under the supervision of Physics lecturers. The whole operation of the Physics lab is conducted in accordance with established safety standards.`,
    image: [phy_lab],
  },
  {
    id: 9,
    infra_title: "Home Science Laboratory",
    description: `Home Science is a very important subject in gaining knowledge to meet the challenge of day-to-day life with confidence. The school has a well-equipped Home-Science Lab where students are acquainted with hands-on knowledge and skills. The teacher conducts different activities in the lab like cooking, stitching, embroidery, knitting, and home management. The home science students can learn Diet Planning for regular and therapeutic needs, Floor decoration, Tie & Die, Flower Arrangement, Block Printing, Samples of different Stitches, Cooking of different recipes, and Table setting.
    `,
    image: [home_science],
  },
  {
    id: 10,
    infra_title: "",
    description: `The home science teacher demonstrates various recipes on bakery, salads, Indian, Chinese, Mexican, and Italian cuisines. The students learn the art of cooking and hone their culinary skills by using gadgets and equipment. They also make use of these lab facilities in their practice teaching, final skill-in teaching, and craft exam.
    `,
    image: [home_science_2],
  },
  {
    id: 11,
    infra_title: "Art & Craft Room (The Heart of Creativity)",
    description: `The Art Room fosters the creative and intellectual development of the students through quality visual arts programs, facilitated by the arts faculty. The art room drives each child to be curious and original in their work while they study a variety of Art forms such as 2D, 3D, and installations by exploring mediums like acrylic, charcoal, water, dry pastels, oil pastels, pencil coloring, clay, wires, papier mache, etc.
    `,
    image: [arts],
  },
  // {
  //   id: 12,
  //   infra_title: "",
  //   description: `The periods in the Art Room offer each child a learning experience that teaches him or her to be a risk-taker, thinker, inquirer, and a good communicator in a safe environment. The Art teachers help the students in drawing, painting, crafts work, best out of waste, and clay modeling. Providing the students with experiences in art, craft and design enables them to reflect critically on their own and others’ work. We aim that they learn to think and act as artists, working creatively and intelligently.
  //   `,
  //   image: [arts_2],
  // },
  {
    id: 13,
    infra_title: "Library",
    description: `The serene ambiance inspires a love for reading. Information at the click of a fingertip invites young users to delve into the magical world of words and the wealth of research material available. The school has a well-equipped library.  The eclectic collection that export constitutes the Library currently includes over 10,000 books. The Library resources comprise Encyclopedias, Dictionaries on various subjects, general collections, valuable sourcebooks, critical works as well as specific skills-related books on Personality Development, Time Management, and Communication Skills. 

    `,
    image: [library],
  },
  {
    id: 14,
    infra_title: "",
    description: `The Library subscribes to research e-journals, besides subscribing to daily newspapers, magazines, and journals. The Digital library provides access to information not just to widen the horizons of the users' knowledge but also to support a host of their learning activities that range from book learning and newspaper reading to using e-journals and reading e-books.
    `,
    image: [library_2],
  },
  {
    id: 15,
    infra_title: "Cultural Center (Music & Dance Room)",
    description: `This is the place where young musicians start their journey to become great composers & where the children unwind and learn the aesthetics of movement. Classical Dance (Indian & Western), Modern Dance (Indian & Western), Choreography,  Direction,  Vocal  Music (Indian and Western), Instrumental Music (Indian and Western) are all interwoven into the fabric of our educational experience.`,
    image: [cultural],
  },
  {
    id: 16,
    infra_title: "",
    description: `Dance is an ideal means of communication to express what is too deep, too fine for words. HGS’s students learn to choreograph and are conversant with various Indian and Western dance forms like Indian Classical, Jazz, Hip Hop, Salsa and these are some of the most eagerly awaited moments for self-expression and the students can be seen enjoying to the hilt.`,
    image: [cultural_2],
  },
  {
    id: 17,
    infra_title: "",
    description: `Lessons in Indian and Western music generate rich cross-cultural exposure and sensitize the students to this fine art. The Department of Music and Dance is committed to excellence, innovation, learning in action, and entrepreneurship. Our mission is to bridge dance practice and scholarship and to foster interdisciplinary inquiry.`,
    image: [cultural_3],
  },
  {
    id: 18,
    infra_title: "",
    description: `As a trained faculty, we bring a challenging range of perspectives to our teaching and research, and continually re-examine our curriculum to prepare both young and mature aspirants for careers in the ever-evolving field of Performing Arts.`,
    image: [cultural_4],
  },
  {
    id: 3,
    infra_title: "Playgrounds",
    description: `Exercise is good for our body and brain and science is helping back up what we intuitively study the connection between the brain and fitness, and physical activity in school readies the brain for learning.HGS Faridabad offers a large space for various sports and fitness activities. From Physical Education periods, to different events and tournaments, the playgrounds cater to all the needs and keep the mind and body rejuvenated.`,
    image: [playground_1],
    features: ["Cognitive", "Physical", "Social"],
    features_description: [
      "When kids interact with the sensory elements in the outdoors, they get the opportunity to problem-solve and think critically.",
      "School playgrounds promote health through climbing, jumping, and running while providing a controlled environment for physical activity.",
      "School playgrounds offer opportunities for kids to collaborate and engage with each other to overcome challenges.",
    ],
  },
  // {
  //   id: 4,
  //   infra_title: "Transportation",
  //   description: `The school provides an optional facility for students to commute from home to school. This service is offered from various places of Faridabad and Delhi to the school. The buses are operated by experienced & trained drivers/attendants to monitor the children’s safe journey. The school tries to provide safe and comfortable commuting for students from home to school and back. Our buses are specially equipped and fitted with speed governors, rear cameras, first-aid equipment, fire extinguishers, etc.`,
  //   description_image: [bus_1],
  //   custom_class: "custom-img",
  // },
];
export const career_guidance = [
  {
    id: 1,
    title: "Career Counselling Workshop",
    description: `The future depends on what you do today." HGS organised a Career Counseling and Guidance programme to direct the students to move on the right path. Parents from different fields and resource persons were invited to share their journey of success with students so that they could learn different aspects of success. The students engaged in the session, asked queries to have better vision for their future and were satisfied with the guidance.`,
    description_image: [career_1],
  },
  {
    id: 2,
    title: "",
    description: `Career building is a deep rooted process. It becomes tedious for adolescents to choose an appropriate career with great placements and a bright future. School plays an important role in this ever-growing process of finding oneself and establishing oneself.`,
    description_image: [career_2],
  },
  {
    id: 3,
    title: "",
    description: ` ITM Institute of Design & Media conducted a career counselling workshop on career opportunities in online world like “YOUTUBE, VFX, ANIMATION", etc. on Feb 16th ,2022. The key speaker was Ms. Jyotsna Raghunathan, who is a storyteller and a film maker with over 20 years of experience in writing scripts, directing films and working in the educational sector of media and mass communication. She has also specialized in curriculum design and development, as well as making films and writing scripts under her own company banner, Panvision. `,
    description_image: [career_4],
  },
  {
    id: 4,
    title: "",
    description: ` The workshop started with her addressing the issue of confusion being created in youngsters' mind while choosing a career. She talked about the varied courses available for all the streams and how these can be helpful in fulfilling their dreams. The students were attentive and interactive and asked queries like the exams to be taken up, combinations of subjects available, options offered, placements etc. It was an enriching session for the students of grade XII.`,
    description_image: [career_5],
  },
];
export const admission = [
  {
    id: 1,
    title: "Admission Procedure",
    image: false,
    features: [
      "Admissions are granted as and when vacancies are available in any class.",
      "Admission forms are available in the school office on 15 Jan every year from the school office. Registration forms also can be downloaded from the school website.",
      "Admission in classes prep to VIII is granted on a ‘first-come-first-served basis.",
      "For admission in class IX, the entrance exam will be of 2 hrs. in the subjects of Hindi, English, Mathematics, and General Science.",
      "For admission to the class, XI counselling will be conducted for HGS students, and for other students entrance tests will be conducted in the subjects offered, subject to the availability of vacancies. Admissions to X and XII are strictly governed by CBSE norms",
      "Admissions will be granted strictly on the merit of qualified candidates.",
      "25% of seats at the entry point (LKG, UKG & Class I) is reserved for EWS (Economically weaker section/ BPL cardholders) and is filled as per the list sent from the BSA office.",
    ],
  },
  {
    id: 2,
    title: "Age Criteria",
    image: false,
    features: [
      "LKG – A child completing 4 years of age as of 1st April of the Academic year.",
      "UKG - A child completing 5 years of age as of 1st April of the Academic year.",
      "Class 1 – A child must be 6 years of age as of 1st April of the Academic year.",
    ],
  },
  {
    id: 3,
    title: "Documents to be submitted at the time of Admission",
    image: false,
    features: [
      "Attest a Photocopy of Birth Certificate for LKG, UKG, and class I.",
      "Attested photocopy of Progress Report of the child indicating academic performance and participation in co-curricular activities in the school last attended.",
      "Registration with CBSE, in case, admission is sought in classes X and XII on the genuine transfer of parents in addition to (2) & (3) above and a copy of the transfer order of the parents.",
      "EWS/ BPL certificate from competent authority (if applicable).",
      "Character certificate in original from the head of the previous school.",
      "Address Proof of the parents/child",
      `Income certificate of the parents'`,
      "SC/ST/OBC Certificate from the competent authority (if applicable)",
    ],
  },
];

export const curriculum = [
  {
    title: "Primary Curriculum",
    navigation: "primary",
    text: "Designed to nurture the child in all dimensions of his or her life",
    image: primary,
  },
  {
    title: "Secondary Curriculum",
    navigation: "secondary",
    text: "A skills-focused programme that provides students with a broad and balanced knowledge of key subjects",
    image: secondary,
  },
  {
    title: "Senior Secondary Curriculum",
    navigation: "sr-secondary",
    text: "Encompassing learning areas to foster competences in our students",
    image: sr_secondary,
  },
];
export const pre_primary_data = [
  {
    id: 1,
    description:
      "Pre-Primary is the foundational step of education where the learning is imparted to the age group of 3 to 6 years. The curriculum is a blend of both Experiential and Project based learning where the students have hands on experience of the learning resulting them to retain the learning lifelong. We want children to interact with each other and explore various aspects of life which includes taking care of themselves, awareness towards environment, proper physical/mental growth and development, use of mathematical concepts in day-to-day life experiences.",
    description_image: [pre1],
  },
  {
    id: 2,
    title: "",
    description:
      "The benefits of such deep learning at this stage are memory retention, life-skill development and emotional growth. Activity based and Theme curriculum is the focus of the foundational classes where many areas of the curriculum are connected together and integrated with a thematic approach making teaching and learning active and interactive. The starting ground is the uniqueness of the child, active learning, and integration in a group and a collective partnership. This way learning becomes meaningful and a child makes deeper connection with the world.",
    description_image: [pre2],
  },
];
export const primary_data = [
  {
    id: 1,
    title: "Pre-Primary Curriculum",
    description:
      "Pre-Primary is the foundational step of education where the learning is imparted to the age group of 3 to 6 years. The curriculum is a blend of both Experiential and Project based learning where the students have hands on experience of the learning resulting them to retain the learning lifelong. We want children to interact with each other and explore various aspects of life which includes taking care of themselves, awareness towards environment, proper physical/mental growth and development, use of mathematical concepts in day-to-day life experiences.",
    description_image: [pre1],
  },
  {
    id: 2,
    title: "",
    description:
      "The benefits of such deep learning at this stage are memory retention, life-skill development and emotional growth. Activity based and Theme curriculum is the focus of the foundational classes where many areas of the curriculum are connected together and integrated with a thematic approach making teaching and learning active and interactive. The starting ground is the uniqueness of the child, active learning, and integration in a group and a collective partnership. This way learning becomes meaningful and a child makes deeper connection with the world.",
    description_image: [pre2],
  },
  {
    id: 1,
    title: "Primary Curriculum",
    description:
      "The primary curriculum is a blend of both Experiential and Project-based learning where the students have hands-on experience of the learning resulting in them retaining the learning lifelong. Theme curriculum is the focus of the foundational classes where many areas of the curriculum are connected and integrated with a thematic approach making teaching and learning active and interactive.",
    description_image: [primary_curriculum],
  },
  {
    id: 2,
    title: "Interactive Classes ",
    description:
      "Interactive classes encourage students’ participation and engagement for better learning and overall development of a child. As the primary classes are the foundational years of education, HGS has well-equipped Interactive board classrooms, open play areas, activity corners, reading corners, etc. to reduce dependency on textbooks and increase focus on learning by interacting. Students do a lot of activities like making floor games to learn tables and other numeracy-related topics. The children take part in poem recitations, debates, speeches, and group discussions which make them more confident and learn from their peer group.",
    description_image: [interactive],
  },
  {
    id: 3,
    title: "  Happy Classrooms",
    description:
      "Three to seven years are crucial in everyone’s life, here learning grows through analyzing and evaluating an issue, and when it is done through activities and play the way, the method then creates happy classrooms. Learning is done including creativities and activities for the students, making them happy in the course of learning. Students do recreational activities like drawing, painting, making postcards, puppetry, and showcase their talent through ME time.",
    description_image: [happy_classroom],
  },
];
export const secondary_data = [
  {
    id: 1,
    description: `At this stage, students have the choice of a curriculum leading to the All India Secondary School Examination conducted by the Central Board of Secondary Education (CBSE), New Delhi. At Secondary school we offer:
`,
    features: [
      "Languages (English & Hindi)",
      "Science",
      "Mathematics",
      "Social Studies",
    ],
    features_image: [secondary_1],
  },
  {
    id: 2,
    title: "",
    description:
      "The secondary curriculum is aimed for the holistic development of students so that they develop effective communication and critical thinking skills. The syllabus is devised in a manner which ensures the students strengthen their work habits.The subjects chosen in this curriculum prepares the students for further studies.",
  },
];
export const sr_secondary_data = [
  {
    id: 1,
    description: `The Senior Secondary School curriculum further builds on the skills and knowledge acquired by the students in the earlier classes. Life skills like social skills, thinking skills – critical, creative, decision making and problem-solving, emotional skills, and values are embedded in the curriculum. The school offers all three streams at the Senior Secondary level- Science (Medical and Non-Medical), Commerce, and Humanities.`,
    description_image: [sr_secondary_1_1],
  },
  {
    id: 2,
    title: "",
    description: `A combination of subjects helps the students in their niche and areas they want to particularly focus on. It helps them to filter out the vast range of available opportunities. Professional guidance and counselling are very crucial at this stage. The school trains its staff according to the needs and demands of the children.
The school offers academics with a subject combination as: `,
  },
  {
    description: "srsec",
  },
];
export const alumni_data = [
  {
    id: 1,
    title: "Nikhel Bakshi",
    occupation: "Youngest Chief Flying Instructor & Trainer",
    description: `Youngest Chief Flying Instructor & Trainer
    I got the privilege of being a part of HGS, where I not only grew physically but also emotionally and psychologically. The lessons and values taught here are embedded deep into my mind and are a part of my personality. I will cherish the experiences and memories of the school and hon'ble teachers forever. From 2006 - 2016 (10 years), I have been the Youngest Chief flying Instructor/Trainer and have trained more than 300 pilots who are now flying in different airlines in India and in foreign airlines as well. From 2017 till date, I am working as a Captain in Indigo Airlines and holding a management post as well as that of a Fleet Coordinator (Delhi Base). 
    `,
    image: nikhel,
  },
  {
    id: 2,
    title: " Ankita Lal",
    occupation:
      "Additional Senior Civil Judge in Saket District Courts, New Delhi.",
    description: `Additional Senior Civil Judge in Saket District Courts, New Delhi.
    School plays a very important part in our lives. What we are today is because of what we have learnt from our schools. I feel blessed being a part of HGS Faridabad. The school gave me an environment which helped me excel in my academic goals. The teachers were more helpful than I had ever expected. Not only did the school cater perfectly to my academic needs but also helped me build my personality and co-curricular skills.
    `,
    image: ankita,
  },
  {
    id: 3,
    title: "Sandeep Kak",
    occupation: "General Manager - Otis Elevators",
    description: `General Manager - Otis Elevators (Bangalore, Karnataka) 
    The School is a stepping stone, responsible for the overall development of a naive and innocent child into a responsible, sensible, and law-abiding citizen. It is a home away from home for all its students and for me too, HGS was my extended family for five years. The school was responsible for shaping my character and personality. At HGS, I and most of my peers have always felt that teachers were our friends, philosophers, and guides. They cared about every student & always tried to give the best advice.
    `,
    image: sandeep,
  },
  {
    id: 4,
    title: "Bharat Bansal",
    occupation: "Entrepreneur in the USA",
    description: `Entrepreneur in the USA
    HGS has been my alma mater for a long time. I have been extremely lucky to have studied here and have made lifelong friends in this school. FIGS has given a very unique perspective to me and my batch mates, due to its unique setting & approach to education in both curriculum and life skills. I wish the school all the best and will also be available to mentor any junior students if needed. 
    `,
    image: bharat_bansal,
  },

  {
    id: 5,
    title: "Subhadeep Sanyal",
    occupation: "Vice President - Omnivore Partners",
    description: `Vice President - Omnivore Partners 
    I earned a B.Sc. (Hons) in Agriculture from CCS HAU, Hisar where I was the batch topper (2005-09). I completed my Masters degree from IIM Ahmedabad, where I specialized in agribusiness during the PGDM- ABM (2009-11). The reason why I had chosen SOS HGS over other schools in Faridabad was due to the ethos which the school had and still continues to have. The open culture and sense of collaboration among students and faculty, complete sense of freedom for a child's overall growth and the need to be rooted to one's core values were probably the greatest takeaways for me from the school.
    `,
    image: subhadeep,
  },

  {
    id: 6,
    title: "Karan Babbar",
    occupation: "Product Consultant - Accenture Service Private Limited ",
    description: `Product Consultant - Accenture Service Private Limited 
    Excellent education is one where a child's interests are nurtured and built upon. HGS tries to put in all their efforts in imparting excellent education to all the students. It's not only about academics but the extracurricular activities are done in the school to ensure the overall development of a child. During my school days, I was much fascinated by computers and our teachers helped me in building interest by exposing me to different technologies. This exposure helped me in pursuing B. Tech in Computer Science.
    `,
    image: karan,
  },
  {
    id: 7,
    title: "Mr. Ajay Baisla",
    occupation: "Municipal Councilor",
    description: `Product Consultant - Accenture Service Private Limited 
    Excellent education is one where a child's interests are nurtured and built upon. HGS tries to put in all their efforts in imparting excellent education to all the students. It's not only about academics but the extracurricular activities are done in the school to ensure the overall development of a child. During my school days, I was much fascinated by computers and our teachers helped me in building interest by exposing me to different technologies. This exposure helped me in pursuing B. Tech in Computer Science.
    `,
    image: aa,
  },
  {
    id: 8,
    title: "Dr.Rajeev Arora",
    occupation: "Specialised Dentist and Senior lecturer.",
    description: `Specialised Dentist andSenior lecturer at Manav Rachna Dental College. Served as Hony. Secratary  of Indian Dental Association Faridabad in 2012  & 2013 and as President in 2015.
    `,
    image: a,
  },
  {
    id: 9,
    title: "Anchal Gulati",
    occupation: "DD News Anchor",
    image: b,
  },
  {
    id: 10,
    title: "Jeevant",
    occupation: "Professional Photographer",
    image: c,
  },
  {
    id: 11,
    title: "Bhushan Sachdeva",
    occupation: "Chartered Accountant",
    image: d,
  },
  {
    id: 12,
    title: "Devender Chaudhary",
    occupation: "Co convener urban local body",
    image: e,
  },
];
export const admissions_data = [
  {
    id: 1,
    title: "Admission Criteria",
    description: `Admission to the school is made without any distinction of religion, race, caste, place of birth, etc. As regards reservations for SC/ST etc. students, it is governed by the Education Act read, in accordance with the rules on the subject as applicable in the state, organized before each technical examination. Admission is granted as and when vacancies are available in any class. `,
    image: false,
  },
  {
    id: 2,
    title: "",
    description: `Admission forms are available in the school office from the 15th March depending upon the vacancy in different classes. All admissions close by 31st July. Transfer cases from other states can be considered against vacancy even during the running session. For admission in class IX, the entrance exam will be of 2.5 hours in the subjects of English, Mathematics, and Science.
    `,
    image: false,
  },
  {
    id: 3,
    title: "",
    description: `For admission in a class, XI counseling will be conducted for HGS students, and other students' entrance tests will be conducted in the subject offered, subject to the availability of vacancies. Admissions to X and XII are strictly governed by CBSE norms. Admission to other classes shall purely depend on the vacancy and merit of the student. No claim for the seat can be made, whatsoever admission will be granted strictly on the merit of qualified candidates.
    `,
    image: false,
  },
  {
    id: 4,
    title: "",
    description: `Transfer cases from other states can be considered against vacancy even during the running session. For admission in class IX, the entrance exam will be of 2.5 hours in the subjects of English, Mathematics, and Science.
    For admission in a class, XI counseling will be conducted for HGS students, and other students' entrance tests will be conducted in the subject offered, subject to the availability of vacancies.`,

    image: false,
  },
  {
    id: 5,
    title: "",
    description: `Admissions to X and XII are strictly governed by CBSE norms. Admission to other classes shall purely depend on the vacancy and merit of the student. No claim for the seat can be made, whatsoever admission will be granted strictly on the merit of qualified candidates.`,
    image: false,
  },
  {
    id: 6,
    title: "",
    description: `Admission to Nursery- Students must complete 3+ years of age as of April 1, of the academic year.
    Admission to Class 1- Students must complete 5+ years of age as on April 1, of the academic year.
    Admission to LKG- 30% of the seats in class LKG is reserved for BPL card holders/ EWS (Economically weaker section).
    Admission in classes PREP to VIII will be done on a ‘first come first served’ basis. The Principal's or Admission Committee’s decision will be final and binding with regard to all admissions.`,
    image: false,
  },
  {
    id: 7,
    title: "",
    description: `Those seeking admission should produce the following:`,
    image: false,
    features: [
      "Birth certificate",
      "School leaving certificate",
      "Progress card of the previous class",
      "EWS/BPL card if applicable",
      "Address Proof",
      "Character Certificate",
    ],
  },
  {
    id: 10,
    title: "Mode of Payment of Fees",
    description: `Each parent will be provided with a fee Booklet containing Challan for deposit of fees at the school counter. The fee will be paid monthly within 10 days of the beginning of the month at the UCO bank counter, opposite sector 28, Mathura Road. Parents must mention the student's name, admission number, and class with a section at the back of the cheque. In case the fees are not deposited by the due date the same can be paid at the school counter in cash only.`,
    image: false,
  },
  {
    id: 11,
    title: "",
    description: `The fee without late fee is payable till the 21st of the first month at the school fee counter. In case the cheque is dishonored, the payment of Rs 200/- shall be charged extra from the parents. The due fee will have to be paid as long as the pupil’s name is on the rolls.`,
    image: false,
  },
  {
    id: 12,
    title: "",
    description: `Only those pupils who have paid all school dues are permitted to appear for the promotion examination. Parents must clear all fees dues by 31st January to avoid any inconvenience. Admission and Annual Fees will not be refunded if a pupil is withdrawn from the school. Security deposit will be refunded only on production of the receipt copy of the Depositor’s portion of the Fee Challan.`,
    image: false,
  },
  {
    id: 13,
    title: "",
    description: `Students' admission numbers should be written in legible handwriting at the time of depositing the fees. Fees lost on account of the wrong entry of name or admission number shall be the responsibility of the parent and in such a case the student's name shall fall in the defaulter list.`,
    image: false,
  },
];
export const facilities_data = [
  {
    id: 1,
    title: "Spacious Classrooms",
    description: `The School can boast spacious, well-ventilated, and excellently furnished classrooms to make the students learning comfortable and enjoyable. Individual tables and chairs are provided to students to make them independent and self-reliant. These specially designed tables and chairs can be brought together very easily to form circles and semicircles while the lesson is in progress to have group discussions and activities.`,
    image: [spacious_classroom],
  },
  {
    id: 2,
    title: "",
    description: `To avoid carrying heavy school bags,  a special storage facility is provided for every student in the classroom. In all classrooms, display boards are provided to display creative chart works, drawings and paintings, and craftworks. The school has the best infrastructure catering for today’s learning environment – like smart interactive classrooms with ICR facilities and the use of smart board technologies for conducive learning. This facilitates comprehensive learning and makes it enjoyable and an interesting process of learning.
    `,
    image: [spacious_classroom_2],
  },
  {
    id: 3,
    title: "STEM Lab",
    description: `STEM education experiences are made available in a variety of settings by the school as a way of fostering a diverse STEM workforce. Educators are focused on improving science and mathematics instructions employing several approaches to K-12 STEM education. Students also were given opportunities to spend time with professionals in STEM fields. 
    `,
    image: [stem_lab],
  },
  {
    id: 4,
    title: "",
    description: `STEM is an abbreviation that stands for 4 closely related subjects that are Science, Technology, Engineering and Mathematics. These four theoretical and practical subjects are taught together under STEM education and starting from basics to giving precise knowledge of the subjects, professional guidelines are available at the school’s STEM lab. The students are taught by giving them real-life world problems and they are to solve these problems by theoretical and practical approach. 
    `,
    image: [stem_lab_2],
  },
  {
    id: 5,
    title: "Computer Lab",
    description: `The school has a highly sophisticated state-of-the-art computer lab. It is equipped with a computing facility with i3 computers connected through the Local Area Network as well as Wifi. The high-speed internet connectivity of 11 Mbps (24*7) to access vast intellectual resources. These facilities are an integral part of the curriculum.
    `,
    image: [computer_lab_1],
  },
  {
    id: 6,
    title: "",
    description: `Students are expected to use computers in their day-to-day study to meet the challenges of modern learning and to keep pace with global scenarios. Students are provided training on SAP, Tally ERP 9, MS Office-2016, and the Internet. The Institute website has been dynamically designed to update the latest development in the institute on a day to day basis.
    `,
    image: [computer_lab_2],
  },
  {
    id: 7,
    title: "Laboratories",
    description: `A scientific temperament is nurtured through fully equipped and suitably designed laboratories for Physics, Chemistry, and Biology. Students are encouraged to use the facilities for enhancing their innovative and scientific skills. It also provides an open environment for students to experiment and do research work. All these labs are provided with lecture/ seminar areas too. The three divisions of the science department ensure that students do real experiments.
    `,
    image: [laboratories],
  },
  {
    id: 8,
    title: "",
    description: `Our science labs are not just a rich storehouse of costly equipment and the latest gadgets on display. They are workshops of practical experiments going far beyond the limits of the prescribed syllabus. The teachers at the physics, chemistry, and biology labs challenge them with exciting projects, giving them a strenuous time clashing with known principles and existing data. This is a place where the divine curiosity of students is at work.
    `,
    image: [laboratories_2],
  },
  {
    id: 9,
    title: "Home Science Laboratory",
    description: `Home Science is a very important subject in gaining knowledge to meet the challenge of day-to-day life with confidence. The school has a well-equipped Home-Science Lab where students are acquainted with hands-on knowledge and skills. The teacher conducts different activities in the lab like cooking, stitching, embroidery, knitting, and home management. The home science students can learn Diet Planning for regular and therapeutic needs, Floor decoration, Tie & Die, Flower Arrangement, Block Printing, Samples of different Stitches, Cooking of different recipes, and Table setting.
    `,
    image: [home_science],
  },
  {
    id: 10,
    title: "",
    description: `The home science teacher demonstrates various recipes on bakery, salads, Indian, Chinese, Mexican, and Italian cuisines. The students learn the art of cooking and hone their culinary skills by using gadgets and equipment. They also make use of these lab facilities in their practice teaching, final skill-in teaching, and craft exam.
    `,
    image: [home_science_2],
  },
  {
    id: 11,
    title: "Art & Craft Room (The Heart of Creativity)",
    description: `The Art Room fosters the creative and intellectual development of the students through quality visual arts programs, facilitated by the arts faculty. The art room drives each child to be curious and original in their work while they study a variety of Art forms such as 2D, 3D, and installations by exploring mediums like acrylic, charcoal, water, dry pastels, oil pastels, pencil coloring, clay, wires, papier mache, etc.
    `,
    image: [arts],
  },
  {
    id: 12,
    title: "",
    description: `The periods in the Art Room offer each child a learning experience that teaches him or her to be a risk-taker, thinker, inquirer, and a good communicator in a safe environment. The Art teachers help the students in drawing, painting, crafts work, best out of waste, and clay modeling. Providing the students with experiences in art, craft and design enables them to reflect critically on their own and others’ work. We aim that they learn to think and act as artists, working creatively and intelligently.
    `,
    image: [arts_2],
  },
  {
    id: 13,
    title: "Library",
    description: `The serene ambiance inspires a love for reading. Information at the click of a fingertip invites young users to delve into the magical world of words and the wealth of research material available. The school has a well-equipped library.  The eclectic collection that export constitutes the Library currently includes over 10,000 books. The Library resources comprise Encyclopedias, Dictionaries on various subjects, general collections, valuable sourcebooks, critical works as well as specific skills-related books on Personality Development, Time Management, and Communication Skills. 

    `,
    image: [library],
  },
  {
    id: 14,
    title: "",
    description: `The Library subscribes to research e-journals, besides subscribing to daily newspapers, magazines, and journals. The Digital library provides access to information not just to widen the horizons of the users' knowledge but also to support a host of their learning activities that range from book learning and newspaper reading to using e-journals and reading e-books.
    `,
    image: [library_2],
  },
  {
    id: 15,
    title: "Cultural Center (Music & Dance Room)",
    description: `This is the place where young musicians start their journey to become great composers & where the children unwind and learn the aesthetics of movement. Classical Dance (Indian & Western), Modern Dance (Indian & Western), Choreography,  Direction,  Vocal  Music (Indian and Western), Instrumental Music (Indian and Western) are all interwoven into the fabric of our educational experience.`,
    image: [cultural],
  },
  {
    id: 16,
    title: "",
    description: `Dance is an ideal means of communication to express what is too deep, too fine for words. HGS’s students learn to choreograph and are conversant with various Indian and Western dance forms like Indian Classical, Jazz, Hip Hop, Salsa and these are some of the most eagerly awaited moments for self-expression and the students can be seen enjoying to the hilt.`,
    image: [cultural_2],
  },
  {
    id: 17,
    title: "",
    description: `Lessons in Indian and Western music generate rich cross-cultural exposure and sensitize the students to this fine art. The Department of Music and Dance is committed to excellence, innovation, learning in action, and entrepreneurship. Our mission is to bridge dance practice and scholarship and to foster interdisciplinary inquiry.`,
    image: [cultural_3],
  },
  {
    id: 18,
    title: "",
    description: `As a trained faculty, we bring a challenging range of perspectives to our teaching and research, and continually re-examine our curriculum to prepare both young and mature aspirants for careers in the ever-evolving field of Performing Arts.`,
    image: [cultural_4],
  },
];

export const results_data = [
  {
    title: "Toppers: X",
    description_image: [result_10, result_10_1, result_10_2, result_10_3],
    custom_class: "custom-img",
  },
  {
    title: "Toppers: XII",
    description_image: [result_12_1, result_12_2, result_12_3],
    custom_class: "custom-img",
  },
];

export const about_data = [
  {
    title: "About Us",
    description:
      "HGS Faridabad was founded in 1986 by Shri J.N Kaul who was the then President of SOS Children’s Village of India. It is one of the oldest schools in Faridabad with a bunch of exceptionally talented students and alumni. It is a co-educational school with classes from Nursery to XII (Medical, Non-Medical, Commerce, and Humanities).",
  },
  {
    title: "",
    description:
      "The school has world class infrastructure that makes it comfortable for the students to learn and grow. The faculty leaves no stone unturned to look after the development of the students. The alumini’s experiences speak for the successful careers the students established here.",
  },
  {
    title: "Our Values",
    description:
      "HG was a man of principles and ethics. His love and compassion for children is what led him to do the social deed of education and establish SOS Children’s Village Association in 1949. Today, these institutions are active in almost 135 countries, spreading its love and knowledge.",
  },
  {
    title: "",
    description:
      "Our value and virtue is what we strive for and work our very best for all our students to learn and adapt the goodness all over. We teach our children how to excel in not only academics but every field out there and how to make a name and position for self. We teach them how to handle life’s hardships along with book and physical knowledge.",
  },
];
export const nep_data = [
  {
    id: 1,
    icon: <FaSchool />,
    description:
      "HGS pedagogy strives to make the schooling process more insightful. It has expanded the horizon of learning and made it more interesting, and motivating. The aim is to focus on the all-round development of the students rather than focusing only on the theoretical part. This makes them ready to face the outer world.",
    extra_description: ["NEP"],
  },
  {
    id: 2,
    title: "Our Curriculum aims to",
    description: "",
    features: [
      "Encourage students to think critically and solve problems through project-based learning",
      "Seamlessly integrate art into the curriculum to enhance the appreciation for aesthetic visual and performing arts.",
      "Foster holistic development through sports, i.e. Health and Physical Education.",
      "Offer activities for curricular and co-curricular enrichment via clubs and work education.",
      " Engage students in addressing real-world problems and issues important to humanity to lead change.",
      " Provide differentiated teaching-learning activities to personalize learning.",
    ],
  },
  {
    id: 3,
    title: "Key Features of the Curriculum",
    description: "",
    features: [
      "Individualized attention – low student-teacher ratio",
      "Stimulating learning environment",
      "Emphasis on all-round development and co-curricular activities",
      "Integration of ICT and Innovation in the Curriculum",
      "Parental Engagement Programmes",
      " Eco-Literacy Curriculum",
      "360-degree assessment approach",
      "Skill-based subjects Imbibing values & social skills",
    ],
  },
];
export const life_curriculum_data = [
  {
    id: 1,
    description: `Adapting the Life Skill Curriculum in the daily routine of every child at the primary stage is a very crucial part of our education. The basic hygiene importance like handwashing and daily bathing, and the value of chivalry and gratitude towards one another must be taught at their impressionable age and fortified over the years. The three components of the Life Skill Curriculum; the individual life-skill, the social skill, and the effective decision making skills are some of the eminent topics of our syllabus. To not only make our students academic geniuses, but to also refine their social and personal skills is what we aim for.`,
    description_image: [life_skill_1],
  },
  {
    id: 2,
    title: "",
    description: `We believe in testing and creating challenges for our students, so they can break their barriers and overcome their judgemental and stereotypical fears. To educate all of them about daily chores, irrespective of the gender, makes the batchmates comfortable and more open to these topics. The ten core Life Skills adopted by our education system are - 1. Self-awareness, 2. Empathy, 3. Critical Thinking, 4. Creative Thinking, 5. Decision Making, 6. Problem Solving, 7. Effective Communication, 8. Interpersonal relationship, 9. Coping with stress, 10. Coping with Emotion.
    `,
    description_image: [life_skill_2],
  },
];
export const examination_data = [
  {
    id: 1,
    title: "Assesment",
    description: `At specific periods of time, we conduct secure and stable examinations for the students of all grades to not only test their capabilities but also to help them gain self-confidence. The children are marked on the basis of their academic and co-curricular results along with their year-long behaviour and activities.`,
  },
];
export const skill_vocational_data = [
  {
    title:'AI and Robotics',
    extra_description: [
      `At HGS Faridabad, education goes beyond textbooks—we empower students with future-ready skills by integrating Skill Based learning experience that transforms regular ICT classrooms to comprehensive AI and Robotics lab. Designed for CBSE Classes 1 to 12, this curriculum integrates Coding, Artificial Intelligence (AI), Robotics, and ICT, transforming education into an interactive, hands-on experience that fosters curiosity, creativity, and critical thinking.`
    ],
  },
  {
    title: "How are we making your child's future ready?",
    features: [" CBSE-Aligned Curriculum – Integrated Coding & AI Skill Subjects to keep students ahead in the digital age.",
               "Experiential Learning – 18–25 lab activities per grade, encouraging innovation and problem-solving.",
               "Cutting-Edge Technology – Hands-on experience with PictoBlox, Quarky Robots, and Microsoft Office tools.",
              "Empowered Educators – Structured lesson plans, lecture slides, and hands-on training for teachers.",
              "Exclusive Partnership with Adobe Express – To further enhance creativity and digital skills, we have partnered with Adobe Express, enabling students to master design, storytelling, and digital content creation, keeping them prepared for future industry demands.",
            ],
  },
  {
    extra_description: [
      `By blending technology with education, we create an environment where students develop confidence, resilience, and a passion for innovation—preparing them to lead in a tech-driven world.`
    ],
  },
  {
    title: "Vocational Subjects",
    description: [
      `Vocational subjects include more hands-on training and less of the traditional academic learning. We at HGS focus on integrating art with the curriculum for all the students to appreciate the aesthetics and visual performing arts. Practical or first-hand knowledge about the market or trade is a very essential part of the vocational training that we provide to the learners.`,
      `We always prioritize our students and for that we offer differentiated teaching-learning activities as well as personalized learning. All the varied Skill and Vocational subjects are included and taught at our institution. A team of dignified and intellectual teachers is always on the stand to help the students master the subjects.`,
      `Emulating the skill-based model of education as per NEP 2020 and CBSE guidance, we have also introduced the skill subjects at the secondary level. Choosing any one Skill subject at this level can help the child to pursue what truly interests or pleases him or her. This liberty promotes a sense of self-esteem in accepting one’s talents and strengths.`,
    ],
  },
  {
    title: "Classes VI-VIII",
    features: ["Mass Media", "Financial Literacy", "Handicraft"],
  },
  {
    title: "Classes  IX-X",
    features: [
      "Information Technology",
      "Banking & Insurance",
      "Introduction to Tourism",
    ],
  },
  {
    title: "Classes XI-XII",
    features: ["Web Application", "Financial Literacy", "Mass Media "],
  },
];
export const co_curricular_data = [];
export const house_clubs_data = [
  {
    id: 1,
    title: "Sports Club",
    description: `Sports club works in promoting physical and mental fitness and a healthy lifestyle among the students. The club conducts sports meets – both inter-house and inter-school competition. It helps facilitate the process of building the concentration and confidence levels of students. Students participate in different kinds of physical activities that make them active and agile. International Yoga Day was celebrated online at school. Facebook live sessions on fitness and exercising were conducted. The games period forms an integral and important part of the school curriculum. Sports clubs also focus on increasing student participation in various sporting activities.`,
    image: [sports_club],
    icon: [sports_club_icon],
  },
  {
    id: 2,
    title: "Anti-bullying Club",
    description: `The club not only teaches students about the impacts and disastrous effects of bullying but also spreads awareness in the society through slogans, posters, and Nukkad Natak (street plays) performed by the members to acquaint students with the information that helps and supports students in combating bullying.`,
    image: [anti_bullying],
    icon: [anti_bullying_icon],
  },
  {
    id: 3,
    title: "Environment Club",
    description: `The environment club conducts regular workshops and activities like planting trees, conducting seminars, showing children the importance of the environment and how we together need to take steps in the direction of making it better.
    The environment club has published essays on topics about the environment and how it’s our responsibility to save it. Anti-tobacco, anti-crackers, as well as cleanliness drives, are organized by the club in the school. The latest activity is to participate in the ‘Plastic-free Faridabad drive’.
    `,
    image: [environment_club],
    icon: [environment_club_icon],
  },
  {
    id: 4,
    title: "Health Club",
    description: `The health club is spacious, airy, and well equipped with all the modern facilities for catering to an overall fitness regime for the students. The instructors facilitate the process by drafting specialized programmes for the children depending upon their needs. The instructors focus on the nutritional components of the health of students. They inculcate healthy eating habits and impart the importance of a healthy balanced diet for a healthy life.  `,
    image: [health_1],
    icon: [health_club_icon],
  },
  {
    id: 5,
    description: `They conduct activities for maintaining a healthy body and mind. Yoga meditation and Asanas are done with the students for a healthy mind and physical health. Cardio, strengthening exercises, and Zumba exercises are done for making the students agile, energetic, and flexible. Several sports meets are conducted for garnering the sportsmen's spirit in the students.`,
    image: [health_2],
  },
  {
    id: 6,
    title: "Value Club",
    description: `In this fast moving world, it is equally important for one to be empathetic towards everyone. Believing in the name itself, this club is for students to gain confidence and discipline and learn all about values and virtues in their life and implement them. The value club helps students to become independent and respectful members of society.
    `,
    image: [value_club],
    icon: [value_club_icon],
  },
  {
    id: 7,
    title: "Social Impact Club",
    description: `The Social Impact club spreads awareness about self and community. It sensitizes students to the needs of the society and develops a spirit of citizenship in them. The club organizes regular activities to enhance student understanding and involvement in helping their neighborhood communities. It empowers students with compassion, proactiveness and resilience. The latest activity conducted by the club is the ‘Plastic free Faridabad drive’
    `,
    image: [social_impact],
    icon: [social_impact_club_icon],
  },
  {
    id: 8,
    title: "Gender Sensitivity Club",
    description: `This club helps the students understand various genders and their importance in the society. It helps to create awareness about various aspects of all genders and also teaches respect and equality for all. It gives them an understanding of how gender roles affect the personal and professional life of people. It helps to understand ways in which we can work in rebuilding these gender roles for a more cohesive society.
    `,
    image: [gender_sensitivity],
    icon: [gender_club],
  },
  {
    id: 9,
    title: "English Club",
    description: `This club is to boost confidence, language skills, and work ethics from a very early stage. This club ensures that students learn about literature and language through fun games and activities. It provides opportunities to build their confidence, expression, and elocution. It also helps the students to enhance their writing skills by conducting activities like debates, poem competitions, and theatre, etc. where children get to use language in innovative ways to explain their views and feelings.
    `,
    image: [english_club],
    icon: [english_club_icon],
  },
  {
    id: 10,
    title: "Expressions Club",
    description: `The Expression club focuses on developing skills in expressing oneself in non-verbal ways. The class focuses on enhancing the skills of kinesthetic control of the body and helps formulate a connection with the music that goes with it. It develops focus and concentration in students. The club motivates the students to participate and includes all the students with varying abilities to showcase their talents. A spacious expression room, supervised by qualified staff, provides training in music, dance, and drama to inculcate the rich cultural traditional values and skills.
    `,
    image: [expression_club],
    icon: [expression],
  },
  {
    id: 11,
    title: " Budding Authors’ club",
    description: ` Learning in HGS is fulfilling the onus of the all-around development of its students by introducing a host of clubs of creative activities as a part of the weekly timetable of every child. One such club is the 'Budding Authors' Club. The Club endeavors to nurture the writing talent of its members through the Budding Authors’ Programme. The Budding Authors’ Programme works on the principle of inculcating the beneficial habits of reading and writing in growing children. 
    `,
    image: [budding_1],
    icon: [ba],
  },
  {
    id: 12,
    title: "",
    description: `The young learners teeming with energy and curiosity are provided with a creative anchor. The pursuit of reading and writing allows the harnessing and channelizing in the right direction, of this vast reservoir of inquisitiveness. A seasoned writer and trainer develops deep bonds of camaraderie and exerts a positive influence in the holistic development of a child, the effect of which is manifested in every aspect of the child’s life.`,
    image: [budding_2],
  },
  {
    id: 1,
    title: "House System",
    description:
      "The school has four houses. The houses are allotted to the children when they join the school. They remain in the same house till they are a part of the school. The school organizes inter-house competitions in the field of science, computer science, technology, arts, sports, music, and dance. These competitions facilitate healthy competition and generate a house spirit and loyalty among the students.",
    image: [house_system],
  },
  // {
  //   id: 13,
  //   title: "School Disaster Management Committee (SDMC)",
  //   description: `The school disaster management committee makes students aware of the various hazards and disasters. It conducts online and offline sessions where the students are shown the videos like fire safety, earthquake readiness, etc. It conducts mock drills in school so that the children get hands-on experience of dealing with such situations.
  //   `,
  //   image: [sdmc],
  // },
  // {
  //   id: 14,
  //   title: "",
  //   description: ` It also includes making students empathetic towards their classmates, making them understand the varying needs of their fellow students and people. It imparts understanding on concepts like the buddy system, children with special needs (orthopedic, visual, or learning). With this, children become compassionate and helpful towards their classmates and people in need.`,
  //   image: [sdmc_2],
  // },
];

export const houses_school = [
  {
    id: 1,
    title: "Jagriti House (Blue)",
    description: `Jagriti means awakening or consciousness-raising and the house carries the color blue. Blue is symbolic of both the sky and the sea. It creates a connection between people and their surroundings. It is associated with freedom, intuition, imagination, and empathy. It represents intelligence, sincerity, confidence, and strength and is instrumental in the betterment of the mind and the body. Jagriti House represents an inner journey symbolizing wisdom and depth of understanding.
    `,
    color: "#0440B6D6",
    houseImg: [blue],
  },
  {
    id: 18,
    title: "Smriti House (Yellow)",
    description: `Smriti refers to the collection of acara or customary law wherein learning takes place. The house carries the color Yellow. It is the color that represents joy. It symbolizes optimism, enlightenment, and creativity. It fosters positive and logical ways of thinking. The house believes in creating enthusiastic learners and positive thinkers for society
    `,
    color: "#FFF616",
    houseImg: [yellow],
  },
  {
    id: 19,
    title: "Jyoti House (Red)",
    description: `Jyoti means light, the brightness that lets us see and the color is Red. Red is the color that symbolizes fire and blood. This signifies passion, desire, strength, willpower, and determination. It makes students confident and passionate learners.
    `,
    color: "#FF1212",
    houseImg: [red],
  },
  {
    id: 20,
    title: "Pragati House (Green)",
    description: `Pragati house carries the color green and the name means the advancement of something which is the process of helping it to progress. The green house carries the color of life, renewal, and energy. It promotes growth and progress. It is the symbol of Mother Nature and the environment that surrounds it. The importance of instilling sensitivity towards the environmental challenges is an important belief of the house.
    `,
    color: "#24EA03F5",
    houseImg: [green],
  },
];
export const student_council_data = [
  {
    id: 1,
    description: `The school comprises the student council headed by the Head Girl and Head Boy along with the Vice Head Girl and Vice Head Boy. The houses are represented by the House Captains and Vice Captains. The council also has representation for the cultural, sports, and discipline committees represented by students heading these particular areas. 
    `,
    description_image: [student_council_1],
  },
  {
    id: 2,
    title: "",
    description: `The students who are elected as heads of all the various committees and councils are guided and trained for undertaking their responsibility with sincerity and passion by the teachers and house in charge. The responsibility of discipline of other students and maintenance of peace and dignity in school also falls under the duties of these elected leaders. The Student Council not only looks after the school's regulations but also helps the students in various activities and campaigns.`,
    description_image: [student_council_3],
  },
];
export const disclosure_data_general = [
  {
    id: 1,
    title: "S. No",
    name: "INFORMATION",
    description: "DETAILS",
  },
  {
    id: 2,
    title: "1",
    name: "NAME OF THE SCHOOL",
    description: "HERMANN GMEINER SCHOOL FARIDABAD",
  },
  {
    id: 3,
    title: "2",
    name: "AFFILIATION NO (IF APPLICABLE)",
    description: "530080",
  },
  {
    id: 4,
    title: "3",
    name: "SCHOOL CODE (IF APPLICABLE)",
    description: "40078",
  },
  {
    id: 5,
    title: "4",
    name: "COMPLETE ADDRESS WITH PIN CODE",
    description: "SOS ENCLAVE SECTOR 29 FARIDABAD HARYANA-121008",
  },
  {
    id: 6,
    title: "5",
    name: "PRINCIPAL NAME & QUALIFICATION",
    description: "DEBOLEENA CHOWDHURI, M.A, B.Ed.",
  },
  {
    id: 8,
    title: "6",
    name: "SCHOOL EMAIL ID",
    description: "principal.faridabad@hgedu.org",
  },
  {
    id: 9,
    title: "7",
    name: "CONTACT DETAILS (LANDLINE/MOBILE)",
    description: "129-4088575",
  },
];
export const disclosure_data_documents = [
  {
    id: 1,
    title: "S. No",
    name: "DOCUMENTS/INFORMATION",
    description: "UPLOADED DOCUMENTS",
  },
  {
    id: 2,
    title: "1",
    name: "COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/Previous affiliation grant letter.pdf"),
  },
  {
    id: 3,
    title: "2",
    name: "COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/Society Registration (2).pdf"),
  },
  {
    id: 4,
    title: "3",
    name: "COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/NOC (3).pdf"),
  },
  {
    id: 5,
    title: "4",
    name: "COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT’S RENEWAL IF APPLICABLE",
    description: "",
    customcomponent: require("../src/pdf/society.pdf"),
  },
  {
    id: 6,
    title: "5",
    name: "COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/Building Safety Certificate.pdf"),
  },
  {
    id: 7,
    title: "6",
    name: "COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/Fire Safety (1) (1).pdf"),
  },
  {
    id: 8,
    title: "7",
    name: "COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATIONOR SELF CERTIFICATION BY SCHOOL",
    description: "",
    customcomponent: require("../src/pdf/SelfDeclaration.pdf"),
  },
  {
    id: 9,
    title: "8",
    name: "COPIES OF VALID DRINKING WATER, HEALTH AND SANITATION CERTIFICATES AND WATER TESTING REPORT",
    description: "",
    customcomponent: require("../src/disclores2027/1505/Hygiene Certificate (1).pdf"),
  },
];
export const disclosure_data_results = [
  {
    id: 1,
    title: "S. No",
    name: "DOCUMENTS/INFORMATION",
    description: "LINKS OF UPLOADED DOCUMENTS",
  },
  {
    id: 2,
    title: "1",
    name: "FEE STRUCTURE OF THE SCHOOL",
    customcomponent: require("../src/disclores2027/Fee Structure Template 2026.docx"),
  },
  {
    id: 3,
    title: "2",
    name: "ANNUAL ACADEMIC CALANDER.",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/Academic Planner.pdf"),
  },
  {
    id: 4,
    title: "3",
    name: "LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/SMC 2026-27.pdf"),
  },
  {
    id: 5,
    title: "4",
    name: "LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/PTA 2026-27.pdf"),
  },
  {
    id: 5,
    title: "5",
    name: "LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION (AS PER APPLICABLILITY)",
    description: "",
    customcomponent: require("../src/disclores2027/disclosure/LAST THREE YEAR BOARD RESULT (3).pdf"),
  },
   {
    id: 6,
    title: "6",
    name: "BOOK LIST",
    description: "",
    customcomponent: require("../src/pdf/BOOK LIST-HGS Faridabad.docx"),
  },
  // {
  //   id: 6,
  //   title: "5",
  //   name: "LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABILITY",
  //   description: "",
  //   customcomponent: require("../src/pdf/LastThreeYearResult.pdf"),
  // },
  // {
  //   id: 6,
  //   title: "5",
  //   name: "LIST OF HOLIDAYS",
  //   description: "",
  //   customcomponent: require("../src/disclores2027/Holiday List 2026.docx"),
  // },
  // {
  //   id: 7,
  //   title: "6",
  //   name: "RESULT",
  //   description: "",
  //   customcomponent: require("../src/disclores/Board Results Faridabad.xlsx"),
  // },
  // {
  //   id: 7,
  //   title: "7",
  //   name: "INSTITUTIONAL PLANNER",
  //   description: "",
  //   customcomponent: require("../src/disclores2027/HGS Institutional planner 26-27 with Examination.docx"),
  // },

];
export const disclosure_data_staff = [
  {
    id: 1,
    title: "S. No",
    name: "INFORMATION",
    strength: "NUMBER/STRENGTH",
    description: "NAME AND QUALIFICATIONS",
  },
  {
    id: 2,
    title: "1",
    name: "PRINCIPAL",
    strength: "1",
    description: "DEBOLEENA CHOWDHURI, M.A, B.Ed",
  },
  {
    id: 2,
    title: "2",
    name: "VICE PRINCIPAL",
    strength: "NA",
    description: "NA",
  },
  {
    id: 3,
    title: "3",
    name: "HEADMISTRESS/HEADMASTER",
    strength: "01",
    description: "RENUKA BHAT, M.A ,M.Ed",
  },
  {
    id: 3,
    title: "4",
    name: "TOTAL NUMBER OF TEACHERS",
    name1: "PGT",
    name2: "TGT",
    name3: "PRT",
    strength: "",
    description: "62",
    description1: "18",
    description2: "27",
    description3: "17",
  },
  {
    id: 5,
    title: "5",
    name: "TEACHERS SECTION RATIO",
    strength: "",
    description: "1.30",
  },
  {
    id: 5,
    title: "6",
    name: "DETAILS OF SPECIAL EDUCATOR",
    strength: "01",
    description: "Radha Rana, B.Com,Diploma(ASD)",
  },
  {
    id: 6,
    title: "7",
    name: "DETAILS OF COUNSELLOR AND WELLNESS TEACHER",
    strength: "03",
    description: "1.Rajdev, Double M. A , M.SW",
    description1: "2.Geetanshi, M.A (Psychology), PG Diploma (Guidance and Counselling)",
    description2: "3.Kavita Aggarwal M.A ( Science of Living Preksha Meditation and Yoga),M.A (Hind),B.Ed",
  },
];
export const disclosure_data_results_10 = [
  {
    id: 1,
    title: "S. No",
    extra_title: "YEAR",
    name: "NO. OF STUDENTS APPEARED",
    description: "NO. OF STUDENTS PASSED",
    description2: "PASS PERCENTAGE",
    extra_description: "REMARKS",
  },
  {
    id: 5,
    title: "1",
    extra_title: "2023",
    name: "88",
    description: "87",
    description2: "98.86",
    extra_description: "1 Student appeared for supplementary exam and qualified. RESULT: 100%",
  },
  {
    id: 5,
    title: "2",
    extra_title: "2024",
    name: "79",
    description: "77",
    description2: "97.47",
    extra_description: "2 Students appeared for supplementary exam and qualified. RESULT: 100%",
  },
  {
    id: 5,
    title: "3",
    extra_title: "2025",
    name: "106",
    description: "104",
    description2: "98.11",
    extra_description: "",
  },
];
export const disclosure_data_results_12 = [
  {
    id: 1,
    title: "S. No",
    extra_title: "SESSION",
    name: "NO. OF STUDENTS APPEARED",
    description: "NO. OF STUDENTS PASSED",
    description2: "PASS PERCENTAGE",
    extra_description: "AVERAGE",
  },  
  {
    id: 4,
    title: "1",
    extra_title: "2023",
    name: "110",
    description: "108",
    description2: "98.18",
    extra_description: "2 students appeared for supplementary exam and qualified",
  },
  {
    id: 4,
    title: "2",
    extra_title: "2024",
    name: "79",
    description: "79",
    description2: "100",
    extra_description: "",
  },
  {
    id: 4,
    title: "3",
    extra_title: "2025",
    name: "120",
    description: "118",
    description2: "98.33",
    extra_description: "1 student appeared for supplementary exam and qualified",
  },
];
export const disclosure_data_school = [
  {
    id: 1,
    title: "S. No",
    name: "INFORMATION",
    description: "DETAILS",
  },
  {
    id: 2,
    title: "1",
    name: "TOTAL CAMPUS AREA OF THE SCHOOL (IN SQR MTR)",
    description: "14164",
  },
  {
    id: 3,
    title: "2",
    name: "NO. AND SIZE OF THE CLASSSROOM (IN SQR MTR)",
    description: "No. 35,Size: 53.4",
  },
  {
    id: 4,
    title: "3",
    name: "NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQR MTR)",
    description: "No. 09,Size: 95.13",    
  },
  {
    id: 4,
    title: "4",
    name: "NO. AND SIZE OF LIBRARY (IN SQR MTR)",
    description: "No.01,Size: 95.13",
  },
  {
    id: 5,
    title: "5",
    name: "INTERNET FACILITY (YES/NO)",
    description: "YES",
  },
  {
    id: 6,
    title: "5",
    name: "NO. OF GIRLS TOILETS",
    description: "32",
  },
  {
    id: 7,
    title: "7",
    name: "NO. OF BOYS TOILETS",
    description: "32",
  },
  {
    id: 8,
    title: "8",
    name: "NO. OF CWSN TOILETS",
    description: "02",
  },
  {
    id: 9,
    title: "9",
    name: "LINK OF YOU TUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL",
    description: "<a href='https://www.youtube.com/@hgsFaridabad' target='_blank'>https://www.youtube.com/@hgsFaridabad</a>",
  },
];
export const trip_data = [
  {
    id: 1,
    description: `Our school organises field trips and excursions not only to create lifelong memories but also to encourage students to learn. It improves their critical thinking skills and make each student’s learning more interesting. Experiential learning makes understanding easier. The classroom is an effective simulation of the real world, however when learning is shifted into to a real-life situation, it becomes more powerful.`,
    description_image: [trip_cover],
  },
  {
    id: 2,
    title: "",
    description: `Embarking on educational tours, and submerging students into cultural experiences have been found to be invaluable for development and understanding. It is a perspective that cannot be taught, but only experienced for oneself. Going to important historical landmarks and great museums gives students the opportunity to visualise, experience and discuss the topics they study. This gives them a deeper understanding of people, places and situations in life.`,
    description_image: [trip_cover_1],
  },
  {
    id: 3,
    title: "",
    description: `Such trips build a greater bond between students and teachers. The teachers get to know more about their students throughout the trip and this is a great way to build a strong rapport with them. Students who have a personal connection with their teachers are more motivated and connected to what they are being taught.`,
    description_image: [trip_1],
  },
  {
    id: 4,
    title: "",
    description: `One of such trips organised by the school was a field trip to Surajkund Craft Fair. It filled the students with immense joy and helped them explore different cultures. They got to experience the richness and diversity of the handicrafts, handlooms and cultural fabric of India. The students participated in various competitions and dance performances during the fair and secured 3rd position in Inter School Painting Competition.`,
    description_image: [trip_4],
  },
];
export const ncc_scouts_guides_data = [
  {
    id: 1,
    description: `To inculcate discipline and leadership qualities, a large number of students are being trained under the NCC & Scout and Guides for making them capable, sensitized to work for the betterment of society and for enhancing their lifestyle and leadership qualities.`,
  },
  {
    id: 2,
    title: "NCC",
    description: `To establish the quality of leadership, to enhance their grace and to give all the students the pride and confidence, we give all the interested candidates special NCC training. Tough yet specialised physical and mental training along with fun sessions help the participants to develop and relax simultaneously. Specially trained teachers and officers often take various lectures and seminars to help and guide the students.`,
    description_image: [ncc_1],
  },
  {
    id: 3,
    title: "School band",
    description: `Music has always proven to be one of the best therapies and to train the students in all aspects, our school has a special band. Training and understanding of various musical instruments, importance of teamwork and knowledge of musical notes are provided to the students. The school band often performs in different events and functions of the schools for which the equipment is both provided as well as allowed to bring on their own.
    `,
    description_image: [school_band_1],
  },
  {
    id: 4,
    title: "Scouts and Guides",
    description: `All eligible and interested students are given fun but important teachings of scouts and guides. It helps them grow physically, mentally, socially and intellectually. Uniforms and other requirements that we provide are a must to bring in the quality of discipline among them. All of them are expected to learn the rules and regulations by heart and implement the same in their actual lives, hence making them stronger and more confident.`,
    description_image: [scouts_1],
  },
];
export const transportation_data = [
  {
    title: "",
    description: `The school provides an optional facility for students to commute from home to school. This service is offered from various places of Faridabad and Delhi to the school. The buses are operated by experienced & trained drivers/attendants to monitor the children’s safe journey. The school tries to provide safe and comfortable commuting for students from home to school and back. Our buses are specially equipped and fitted with speed governors, rear cameras, first-aid equipment, fire extinguishers, etc.`,
    description_image: [bus_1],
    custom_class: "custom-img",
  },
];
export const award_text_data = [
  {
    title: "",
    description: [
      "HGS proudly highlights its achievements and presents the best of its students, whether they are excelling academically, athletically or in service to the community. We hope to inspire more students to excel, their achievements ultimately make the school become stronger.",
      "By highlighting student achievements, we aim to eliminate self-doubt and build confidence in our students that hard work is important and is making an impact. In turn, this confidence can carry over to other facets of their young lives, including making smart choices when faced with several challenges as they grow up.",
    ],
  },

  {
    features: [
      "Global School Award for Innovation in Pedagogical Practices in 2020",
      "Best Teaching Excellence Award by International School Award held at Dubai in 2018",
      "Indian School Award in 2018",
      "National School Award 2018",
      "Global Sustainable School Award 2017 as a recognition of its efforts towards community service and environment",
    ],
  },
];
// the long list of awards such as
//stand testimony to the fact that the school never rests on its laurels.

export const awards_data = [
  {
    title: "",
    image: award_8,
  },
  {
    title: "",
    image: award_10,
  },
  {
    title: "",
    image: award_9,
  },
  {
    title: "",
    image: award_1,
  },
  {
    title: "",
    image: award_2,
  },
  {
    title: "",
    image: award_3,
  },
  {
    title: "",
    image: award_4,
  },
  {
    title: "",
    image: award_5,
  },
  {
    title: "",
    image: award_6,
  },
  {
    title: "",
    image: award_7,
  },
];
export const news_text_data = [
  {
    description:
      "HGS has been incessantly creating fervor in society and has been garnering Media coverage, getting its message across to a wider audience and establishing itself as a credible school and its activities as notable.Reputed newspapers have on several ocaasions, published the events and happenings at HGS along with the laurels and accolades received. We humbly acknowledge this recognition and strive to be a responsible school and be dedicated towards the community welfare.",
  },
];
export const news_data = [
  {
    title: "",
    image: media1,
  },
  {
    title: "",
    image: media2,
  },
  {
    title: "",
    image: media3,
  },
  {
    title: "",
    image: media4,
  },
  {
    title: "",
    image: media,
  },
  {
    title: "",
    image: media6,
  },
  {
    title: "",
    image: media8,
  },
  {
    title: "",
    image: media9,
  },
  {
    title: "",
    image: media10,
  },
  {
    title: "",
    image: media11,
  },
  {
    title: "",
    image: media12,
  },
  {
    title: "",
    image: media13,
  },
  {
    title: "",
    image: media14,
  },
  {
    title: "",
    image: media15,
  },
];
export const alumni_text_data = [
  {
    id: 1,
    title: "Nikhel Bakshi",
    occupation: 'Youngest Chief Flying Instructor & Trainer',
    description: `I got the privilege of being a part of HGS, where I not only grew physically but also emotionally and psychologically. The lessons and values taught here are embedded deep into my mind and are a part of my personality. I will cherish the experiences and memories of the school and hon'ble teachers forever. From 2006 - 2016 (10 years), I have been the Youngest Chief flying Instructor/Trainer and have trained more than 300 pilots who are now flying in different airlines in India and in foreign airlines as well. From 2017 till date, I am working as a Captain in Indigo Airlines and holding a management post as well as that of a Fleet Coordinator (Delhi Base). 
    `,
    image: nikhel,
  },
  {
    id: 2,
    title: " Ankita Lal",
    occupation: 'Additional Senior Civil Judge in Saket District Courts, New Delhi',
    description: `School plays a very important part in our lives. What we are today is because of what we have learnt from our schools. I feel blessed being a part of HGS Faridabad. The school gave me an environment which helped me excel in my academic goals. The teachers were more helpful than I had ever expected. Not only did the school cater perfectly to my academic needs but also helped me build my personality and co-curricular skills.
    `,
    image: ankita,
  },
  {
    id: 3,
    title: "Sandeep Kak",
    occupation: 'General Manager - Otis Elevators (Bangalore, Karnataka)',
    description: `The School is a stepping stone, responsible for the overall development of a naive and innocent child into a responsible, sensible, and law-abiding citizen. It is a home away from home for all its students and for me too, HGS was my extended family for five years. The school was responsible for shaping my character and personality. At HGS, I and most of my peers have always felt that teachers were our friends, philosophers, and guides. They cared about every student & always tried to give the best advice.
    `,
    image: sandeep,
  },
  {
    id: 4,
    title: "Bharat Bansal",
    occupation: 'Entrepreneur in the USA',
    description: `HGS has been my alma mater for a long time. I have been extremely lucky to have studied here and have made lifelong friends in this school. FIGS has given a very unique perspective to me and my batch mates, due to its unique setting & approach to education in both curriculum and life skills. I wish the school all the best and will also be available to mentor any junior students if needed. 
    `,
    image: bharat_bansal,
  },

  {
    id: 5,
    title: "Subhadeep Sanyal",
    occupation: 'Vice President - Omnivore Partners ',
    description: `I earned a B.Sc. (Hons) in Agriculture from CCS HAU, Hisar where I was the batch topper (2005-09). I completed my Masters degree from IIM Ahmedabad, where I specialized in agribusiness during the PGDM- ABM (2009-11). The reason why I had chosen SOS HGS over other schools in Faridabad was due to the ethos which the school had and still continues to have. The open culture and sense of collaboration among students and faculty, complete sense of freedom for a child's overall growth and the need to be rooted to one's core values were probably the greatest takeaways for me from the school.
    `,
    image: subhadeep,
  },

  {
    id: 6,
    title: "Karan Babbar",
    occupation: 'Product Consultant - Accenture Service Private Limited',
    description: `Excellent education is one where a child's interests are nurtured and built upon. HGS tries to put in all their efforts in imparting excellent education to all the students. It's not only about academics but the extracurricular activities are done in the school to ensure the overall development of a child. During my school days, I was much fascinated by computers and our teachers helped me in building interest by exposing me to different technologies. This exposure helped me in pursuing B. Tech in Computer Science.
    `,
    image: karan,
  },
];
export const sports_data = [
  {
    id: 1,
    title: "Sports",
    description: `Having an active lifestyle is key to living a healthy and fit life. To ensure that our students are not only just engrossed in studies, to promote a spirit of sportsmanship and camaraderie, we encourage the students to participate in regularly held intra and inter school events within and outside of the HGS community. Taekwondo, Football, Badminton, Lawn Tennis, Table Tennis, Cricket, Chess and Yoga`,
  },
];

export const faculty_data = [
  {
    title: "Faculty & Staff",
    description: `HGS Faridabad has a very experienced, knowledgeable, 
    well-qualified and dedicated Staff, so much so that they are conscious of their 
    responsibility of being the most important block in the foundation of the Nation 
    as well as the Society.`,
    description_image: [faculty_1, faculty_2],

    custom_class: ["faculty-img"],
    extra_description: [
      `Their self-discipline is an example in itself, which always drives them to work as 
    a well-knit team to make all possible endeavour together for the holistic growth 
    of students as well the institution. They are enthusiastic, dedicated, 
    conscientious and highly motivated to adapt to new innovative ideas and well 
    versed with modern education systems.`,
      `The valuable contribution of all the Faculty members is well manifested in the 
    spectacular achievements of our students in the scholastic as well as co-
    scholastic discipline.`,
      `The Teachers grouped under various subject-wise Faculties are put under the 
    guidance of the most experienced Faculty heads. All of them always put their 
    heads together to devise improvised methodology to deliver their best to 
    facilitate the young evolving minds. This significantly contributes in promoting 
    the problem solving skills of students to enable them to grow as useful citizens.`,
    ],
  },
];

export const events_data = [
  {
    month:``,
    year:``,
    createdate:``,
    title: "Run A Mile – The Marathon Experience",
    discription: `On August 12, 2023, HG Educational Institutions hosted the event "Run a Mile - The Marathon Experience." This event garnered an incredible response, with participation from over 1000 individuals spanning the age range of 5 to 75 years. The enthusiastic cheers of the audience resonated throughout the area, creating an electrifying atmosphere.
        The presence of esteemed local authorities, including MLA, Mr. Rajesh Nagar and the Deputy Commissioner of the Police Force, added a profound sense of accomplishment and pride among the participants. It was a memorable and successful event that brought the community together to celebrate health, fitness, and unity.`,
    image: [runamile],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "Annual Day Celebrations",
    discription: `Annual Day forms an integral part of our school activities. It is an occasion of celebration, felicitation, feast and festivity when students present not only their wonderful performances but also receive honours for their curricular and co-curricular achievements.`,
    image: [annual_1],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: 'The Theme of the Annual Day was "Technoutsav"',
    discription: `The Annual Prize Distribution function was a moment of pride and honour for all the winners and achievers of the school. The students were awarded prizes in the Academic as well as Co Curricular areas. The function included Saraswati Vandana, Orchestra by the students and Fusion Dance.`,
    image: [annual_3],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: ` Principal Mr. Subrata Kundu  extended a warm welcome to the dignitaries and presented the Annual Report. He read out the achievements of the school both Academic and Co curricular and wished success to the students who could not make up for the prizes.`,
    image: [annual_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Republic Day Celebration`,
    discription: `On 26th January 2022, HGS Faridabad commemorated the 73rd Republic Day on the live and virtual platform with great patriotic fervour, mirth, and zest. The zealous students of HGS demonstrated that even though the pandemic has confined them to their homes, it cannot dampen their patriotic spirit and pride for the nation. `,
    image: [republic_1],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `The programme was graced by the distinguished presence of our revered Principal Mr. Subrata Kundu with our Guest of Honour Mrs. Ankita Lal (Alumnus of HGS Faridabad batch 2000), Judicial Officer in New Delhi, Headmistress (Senior School), Ms. Vandana Tomar, Headmistress (Primary School), Ms. Manjeet Kaur, respected teachers, parents, and the learners. The programme commenced with the unfurling of our Indian Flag and reflection upon the values of courage, strength, peace, truth, growth and progress that the tricolour teaches us to adopt. As the session unfolded, our Principal, Mr. Subrata Kundu, inspired the students with his motivational words. He hailed the power of youth and urged the learners to assume the role of building up the nation. `,
    image: [republic_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription:
      " The presentation further included speech, dances, song, instrumental presentation, Hindi and English poems and role play and impactful videos of primary and preprimary students. Through the show, students paid tribute to the sacrifices made by the freedom fighters.They emphasised how the Republic Day celebration reaffirms our commitment to unity in diversity. The programme concluded with the encouraging words of the school Headmistresses, Ms. Manjeet Kaur who congratulated the entire team and the participants for this wonderful presentation. Their hearts swelled with pride to see the young children grow into confident and aware individuals - ready to take on the world with the light of hope and positivity.",
    image: [republic_3],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Basant Panchami`,
    discription: `The festival of Basant Panchami, which marks the end of winter and the onset of spring is celebrated on the fifth day (Panchami) of the Hindu month of Magha. This day is considered to be the birthday of Goddess Saraswati, as she is said to have appeared on earth to dispel the gloom of all living beings, through the gift of speech and music. Our children celebrated this festival with great zeal by wearing yellow clothes, preparing yellow food with the help of their parents, participating in online celebrations & also making colourful kites. We ended this celebration by inculcating the values & keeping in mind our tradition.`,
    image: [basant_1],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "Activity 1",
    discription: `Students of class V are learning through experiencing, during online classes. They are making innovative projects under the guidance of teachers like making Air coolers, and Vacuum cleaner with the help of waste materials available at home. The cooler consumes less electricity as compared to big coolers and is portable which we can carry in vehicles and works without electricity on battery too. This activity is a perfect example of learning by doing.`,
    image: [basant_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "Activity 2",
    discription: `The students of 5th Grade made a model of lungs while their course of learning. The process of breathing was learned by them through hands-on experience which made their concept more clear about exhaling and inhaling done by our respiratory system.`,
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Donation Drive`,
    discription: `“THE WORLD NEEDS EVERY SUPPORTING HAND WE CAN MUSTER.”
    Eco Club of HGS Faridabad organized a donation drive initiative for Vanprasth Vridhjan Sewa Sadan, an old age home in sector 28, Faridabad where interactions were expressed their gratitude by conducting a donation of vegetables grown by students in the School Nutrition Garden. SNG promotes students to get connected to a natural world and makes them aware of the true source of their food, teaches them valuable gardening and agriculture concepts and skills that integrate with several subjects maths, science, health & physical education as well as interpersonal and social responsibility.
    `,
    image: [donation_1],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `Mr. Ramesh K. Dhar, Principal along with the team of students and teachers came forward and handed over the fresh vegetables to Mr. Anil Sarin, President of the old age home. Receiving a fairly nice amount of vegetables and face masks for the inmates, he was thrilled. This attempt to help the people may not alleviate all their problems but may decrease their suffering to some extent.These community activities organized by the school are not just a display of our social responsibility but also a forum to instil the values of empathy and compassion among students. These are life skills demonstrated in action.`,
    image: [donation_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Paper Bag`,
    discription: `"There is no exercise better for the heart than reaching down and lifting people." HGS Faridabad has been actively involved in community service and has sought ways to enhance this involvement. It strives to provide a range of social service opportunities that will allow our students to expand their understanding of social issues and consider their role in finding solutions to community concerns. The Social Impact team organised a PAPER BAG-making workshop using an old newspaper for FSP Tilak Nagar beneficiaries. The students of grade IX gave training on paper-bags making and awareness on reducing single-use plastic bags to 10 women of FSP. It helps them to get employment and generate income. At the end of the session, the special guests were gifted with fresh vegetables harvested from the School Nutritional Garden.`,
    image: [paper],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Waste Is Not A Waste `,
    discription: `Little hands and imaginative minds of HGS Faridabad came together in a creative burst of energy during the activity of the “Waste is not a waste” Project.The project aims to bring our learners to understand the importance of preserving the environment and learn more about sustainability. We should not throw away wasted things, we could use them again for different purposes, and we should not cause harm to nature. `,
    image: [waste],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription:
      "To make children aware of the uses of waste material, this “WASTE IS NOT A WASTE” Project was initiated for students.Students of all divisions prepared very creative and innovative models and art items from different waste materials. They used reusable and recyclable materials like newspapers, tires, shoe boxes, ice cream sticks, and much more. From these items, they created an amazing array of display items and useful everyday objects. The values like preservation, recycling, conservation, reduction, reuse, etc are imbibed into the young heart and minds by demonstrating this noble act of caring for our environment",
    image: [waste_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Pareeksha Pe Charcha `,
    discription: `The students were made to witness the most awaited event of the year in the school auditorium today. Pariksha Pe Charcha is part of the larger movement - ‘Exam Warriors’ - led by Prime Minister Narendra Modi, to create a stress-free atmosphere for youngsters. It is a movement that is driven by Prime Minister Narendra Modi's efforts to bring together students, parents, teachers, and the society to foster an environment where the unique individuality of each child is celebrated, encouraged, and allowed to express itself fully. `,
    image: [pareeksha],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `The Prime Minister urged everyone to put exams in the right perspective, rather than making it a life-and-death situation punctuated by undue stress and pressure. The Exam Warriors module on NaMo App adds an interactive tech element to the Exam Warriors movement. He communicated the core messages of each mantra and thought-provoking but enjoyable activities that help absorb concepts through practical means.`,
    image: [pareeksha_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Heritage Day Celebration`,
    discription: `A Celebration of World Heritage Day was organised at HGS Faridabad to promote awareness among students about the diversity of culture, heritage, monuments and sites.A special session was conducted for the students in which the teacher talked about the true meaning of heritage, its importance and the need for its preservation. A beautiful video was showcased on seven incredible and famous heritage sites of the world. Students of grade IX told stories about Indian heritage sites. Students of grade X made travel brochures on famous monuments and participated wholeheartedly.The objective behind the activity was to enlighten students about the value and significance the world’s heritage holds. Children were familiarised with the rich cultural heritage we have.`,
    image: [heritage],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Farewell 2021-22`,
    discription: `Schooling remains the most precious time in the life of an individual and when there comes a moment to bid adieu to one's alma mater, the flow of emotions possesses its finest grace.With their hearts filled with the pride of having been associated with one of the best institutes that they could always relish as their second home, the 12th Class Students of HGS were given a Hearty Send-Off in a gracious Farewell Ceremony by their juniors of XI Class. `,
    image: [farewell],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `Through a well-organized cultural evening comprising Dances, Songs, Speeches, and Poetry, an atmosphere of love and affection was created. Class XI students presented beautiful attractive gifts to their seniors. The presence of the esteemed Principal of the school, Mr. Ramesh Dhar, and reverent HMs, Ms. Vandana Tomar and Ms. Manjeet Kaur lent an additional charm to the occasion. They showered their blessings upon the students and also motivated the students to develop a tendency of hard work, perseverance, and dedication towards work.`,
    image: [farewell_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "Mock Fire Evacuation Drill",
    discription: `HGS Faridabad believes it's the responsibility of the school to ensure the safety of its students and staff, and prepare them for any unforeseen emergency. With the kind help of Mr. Ashok (Fire Safety Expert), a mock fire and evacuation drill was conducted at HGS today on 26th April 2022. Following an alarm, teachers and other school staff swung into action and performed the duties allotted to them. Students were educated about the safety and precautionary measures to be taken at the time of the fire and other natural disasters. Students were also given tips on fire safety. A demonstration of using fire safety equipment was also conducted by the experts.`,
    image: [fire],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Earth Day`,
    discription: `"The earth is what we all have in common.” – Wendell Berry .The students of Grade 3 to 5 did an activity to show their love and concern for Mother Earth and its well-being. The students of Grade 3 made bags out of paper and Grade 5 made cloth bags. The children not only learned the importance of our precious environment but also how to save it.`,
    image: [environment],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "Kids Fashion Fiesta",
    discription: `HGS Faridabad organized Kids Fashion Fiesta for the early years where distinct topics were given to the little ones according to their age.
    It was a successful event full of creativity and involvement of the parents too. Kids enjoyed being dressed up and everyone was happy for being part of the program.
    The program was graced by our Respected Head of Education and Child Development Ms. Debaroti Bose and the students were excited by her presence. The event was concluded by our Respected Headmistress Ms. Manjeet Kaur on a happy and positive note.`,
    image: [fashion],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Book Donation Drive`,
    discription: `We Rise by Lifting Others!
    Compassion and community welfare are the essences of any good human being; hence an initiative was taken by our Social Impact Club to inculcate these virtues amongst our learners.
   The school established a Book Bank facility for the underprivileged children of Gurukul of SOS FSP, Anangpur. Students of Grade IX initiated the project by sorting and packing the numerous books received through the Book Donation Drive organized in the school. They were donated to the children of Baal Panchayat, wherein children do not have the means to buy them. Our children also guided them on how to run the Book Bank. The effort resulted in a fruitful outcome, as children passed the gift of education in their own selfless way.`,
    image: [book],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Mothers Day`,
    discription: `Motherhood is the exquisite inconvenience of being another person's everything.
    “When you are looking at your mother, you are looking at the purest love you will ever know.”
   There is one extraordinary relationship in this life that is truly priceless in terms of love, dedication, and devotion and that is of mother and child. The bond between a mother and her child is something that is cherished for eternity and one day is surely not enough to celebrate motherhood. However, every year, a day is specially marked for mothers all across the globe to pay homage to their selfless and unconditional love. The Mothers’ Day activities conducted for Grades VI & IX at HGS witnessed the creativity of the rising stars who prepared beautiful tiaras or bracelets, flowers, cards, photo frames for their mothers.`,
    image: [mother],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Covid Vaccination Drive`,
    discription: `To contain the swell of Corona Variants by protecting students from this lethal virus, a vaccination drive was organized at HGS Faridabad in association with Civil Surgeon, Health Department, Haryana on 19th May 2022 for the students of the age bracket 12 years to 15 years (Classes VI to X) at its campus. This drive followed all the norms laid by WHO, the Ministry of Health, Government of India pertaining to Covid 19.
    Mr. Ramesh Dhar, the Principal, asserted that students’ safety was the prime concern for the school. The initiative of the school ensured safe vaccination for the students and allowed children in the vicinity to get benefitted.
    `,
    image: [covid],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `Orientation Day Programme`,
    discription: `“A parent is a teacher at home and a teacher is a parent in school and the child is the center of our universe.” An Orientation Programme was organised for the parents of new admission at HGS Faridabad on 21st May 2022. The aim was to familiarise the parents, “as partners in progress” with the curriculum, rules, and regulations of the school, teaching methodologies, and the co-scholastic activities. The programme commenced with a warm welcome to the parents followed by the ceremonial lighting of the lamp. The School Principal, Mr. Ramesh Dhar, addressed the gathering. In his speech, he laid stress on effective communication between the teachers & the parents and also sought their support and suggestions so that the children could be provided the best for their overall development. He also gave guidelines about effective parenting. `,
    image: [orientation_1],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `The parents were briefed about the curriculum, and teaching methodologies along with new initiatives of the school by the headmistress senior wing, Ms. Vandana Tomar. Later, Ms. Anuradha Rai Shukla, Examination Incharge presented information about the examination and promotion policies of the school. Not to forget the co-scholastic activities, briefed by Ms. Nidhi Sharma, Activity Coordinator, which assured them that the curriculum involves self-directed, hands-on learning activities which not only give vent to their creative talents and energies but also help in the all-round development of the child. `,
    image: [orientation_2],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `She also explained about the school app. It was followed by a session taken by HM Junior Wing, Ms. Manjeet Kaur, who guided the parents about various principles, curriculum, and activities involved in the teaching in primary and pre-primary classes. The parents witnessed and enjoyed the dance performance by Primary children and a mashup by middle wing girls. The orientation program ended with an interactive session with the parents and a vote of thanks by HM Maam.`,
    image: [orientation_3],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: "",
    discription: `The orientation program proved to be a sincere effort made by the school in educating the parents to look after and properly guide their children. It also helped in evolving a common teaching strategy and helped the parents in identifying suitable follow-up methods to reinforce the learning process of their children.Overall it was a fruitful meeting and the parents were in high spirits after attending the orientation programme.`,
    image: [orientation_4],
  },
  {
    month:``,
    year:``,
    createdate:``,
    title: `First Aid Kit Making Activity`,
    discription: `From a minor ailment to a more serious injury, a "First Aid Kit" can help reduce the risk of infection. Keeping this in mind, our SDMC First Aid Team organised a First Aid Kit Making Activity for the young students of Grade III to VIII on 21st May 2022. Those children were allowed to prepare a First Aid Kit in the class. The kit included cotton swabs, an antiseptic, band-aids, pain relief ointment, etc. The children learned how these medical items can be used to treat minor cuts, burns, and scrapes, and that a first aid kit should always be kept clean and organised. This activity helped the children to learn basic first aid skills and how to make the first aid box that can enable them to care for themselves in any kind of emergency.`,
    image: [first_aid],
  },
];
